export const imageBoxes256 = [
  {
    id: "bc646a21-d8a4-4700-8783-fc87accdcc5d",
    label: "RGB(41,41,41)",
    type: "ImageBox",
    description: "Size: 5548856 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 0,
      y: 0,
    },
    bottomRight: {
      x: 799.7093023255815,
      y: 599.7093023255815,
    },
  },
  {
    id: "e5d4c83c-9bf1-4f16-b350-63ee613e4a9b",
    label: "RGB(63,63,63)",
    type: "ImageBox",
    description: "Size: 386 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 341.8604651162791,
      y: 304.0697674418605,
    },
    bottomRight: {
      x: 364.5348837209303,
      y: 313.08139534883725,
    },
  },
  {
    id: "4583b0f9-74e2-4edf-abdb-9140f31882db",
    label: "RGB(74,74,74)",
    type: "ImageBox",
    description: "Size: 361 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 343.31395348837214,
      y: 304.3604651162791,
    },
    bottomRight: {
      x: 362.79069767441865,
      y: 311.3372093023256,
    },
  },
  {
    id: "68af83d3-9323-4e71-92de-7b00c6f3e14e",
    label: "RGB(85,85,85)",
    type: "ImageBox",
    description: "Size: 79 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 348.546511627907,
      y: 305.2325581395349,
    },
    bottomRight: {
      x: 357.84883720930236,
      y: 307.84883720930236,
    },
  },
  {
    id: "d1f770dc-0e20-4457-9ea9-959dc3e8d63e",
    label: "RGB(81,81,81)",
    type: "ImageBox",
    description: "Size: 17 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 308.43023255813955,
      y: 309.01162790697674,
    },
    bottomRight: {
      x: 310.75581395348837,
      y: 310.4651162790698,
    },
  },
  {
    id: "30b888d0-bf00-4eba-8c89-2aa00b6f8639",
    label: "RGB(104,104,104)",
    type: "ImageBox",
    description: "Size: 19 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 308.72093023255815,
      y: 309.593023255814,
    },
    bottomRight: {
      x: 310.75581395348837,
      y: 311.3372093023256,
    },
  },
  {
    id: "b0598277-d8ce-4e3f-b96f-8eac55c43630",
    label: "RGB(117,117,117)",
    type: "ImageBox",
    description: "Size: 213 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 309.3023255813954,
      y: 310.1744186046512,
    },
    bottomRight: {
      x: 320.63953488372096,
      y: 316.8604651162791,
    },
  },
  {
    id: "4f7f3d14-6744-4981-ba95-fc89641c7215",
    label: "RGB(53,53,53)",
    type: "ImageBox",
    description: "Size: 952 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 345.05813953488376,
      y: 310.1744186046512,
    },
    bottomRight: {
      x: 367.4418604651163,
      y: 325.2906976744186,
    },
  },
  {
    id: "88b2cde9-4d5a-4503-a8e2-a6c6cdca2ae9",
    label: "RGB(129,129,129)",
    type: "ImageBox",
    description: "Size: 113 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 309.8837209302326,
      y: 310.75581395348837,
    },
    bottomRight: {
      x: 315.98837209302326,
      y: 316.27906976744185,
    },
  },
  {
    id: "99d232b5-5618-4ef2-8075-1e2e3bcf739b",
    label: "RGB(52,52,52)",
    type: "ImageBox",
    description: "Size: 25 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 319.4767441860465,
      y: 310.75581395348837,
    },
    bottomRight: {
      x: 322.093023255814,
      y: 313.08139534883725,
    },
  },
  {
    id: "ac91a05d-76db-40bd-91a7-c928c6a17b74",
    label: "RGB(53,53,53)",
    type: "ImageBox",
    description: "Size: 21 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 288.37209302325584,
      y: 311.3372093023256,
    },
    bottomRight: {
      x: 290.98837209302326,
      y: 313.66279069767444,
    },
  },
  {
    id: "705c37da-f7b8-4b97-b3ff-a883a78357b0",
    label: "RGB(64,64,64)",
    type: "ImageBox",
    description: "Size: 27 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 320.05813953488376,
      y: 311.3372093023256,
    },
    bottomRight: {
      x: 322.3837209302326,
      y: 314.5348837209302,
    },
  },
  {
    id: "9a4846e1-1349-48ab-b165-65f4eadf3223",
    label: "RGB(64,64,64)",
    type: "ImageBox",
    description: "Size: 123 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 363.66279069767444,
      y: 311.3372093023256,
    },
    bottomRight: {
      x: 366.5697674418605,
      y: 321.8023255813954,
    },
  },
  {
    id: "b993a52f-e164-4d02-aecd-40ec8189d882",
    label: "RGB(64,64,64)",
    type: "ImageBox",
    description: "Size: 224 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 288.66279069767444,
      y: 311.6279069767442,
    },
    bottomRight: {
      x: 295.93023255813955,
      y: 316.5697674418605,
    },
  },
  {
    id: "535ee17a-a5d9-4de6-8f26-2def9c22c757",
    label: "RGB(53,53,53)",
    type: "ImageBox",
    description: "Size: 157 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 325.87209302325584,
      y: 311.6279069767442,
    },
    bottomRight: {
      x: 332.2674418604651,
      y: 316.5697674418605,
    },
  },
  {
    id: "3e7aeae7-026f-426b-8a35-1553dce7cb9e",
    label: "RGB(75,75,75)",
    type: "ImageBox",
    description: "Size: 23 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 319.7674418604651,
      y: 311.9186046511628,
    },
    bottomRight: {
      x: 322.093023255814,
      y: 313.95348837209303,
    },
  },
  {
    id: "7afdedf5-48b7-45ad-9a90-31887f6240ea",
    label: "RGB(76,76,76)",
    type: "ImageBox",
    description: "Size: 61 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 288.95348837209303,
      y: 312.2093023255814,
    },
    bottomRight: {
      x: 291.8604651162791,
      y: 315.1162790697675,
    },
  },
  {
    id: "9000b679-e62e-41b6-8029-3bef87a297cf",
    label: "RGB(90,90,90)",
    type: "ImageBox",
    description: "Size: 42 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 318.0232558139535,
      y: 312.5,
    },
    bottomRight: {
      x: 321.8023255813954,
      y: 316.8604651162791,
    },
  },
  {
    id: "f82b9365-97c9-41db-835a-819f7b3e46ba",
    label: "RGB(52,52,52)",
    type: "ImageBox",
    description: "Size: 222 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 342.7325581395349,
      y: 312.5,
    },
    bottomRight: {
      x: 352.0348837209302,
      y: 320.34883720930236,
    },
  },
  {
    id: "b23dd298-1c52-4ca9-aab6-b1ee8a2ed88e",
    label: "RGB(64,64,64)",
    type: "ImageBox",
    description: "Size: 53 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 327.0348837209302,
      y: 312.7906976744186,
    },
    bottomRight: {
      x: 330.81395348837214,
      y: 315.69767441860466,
    },
  },
  {
    id: "738fe0c7-2cf3-4345-b8d2-7bc689129664",
    label: "RGB(93,93,93)",
    type: "ImageBox",
    description: "Size: 12 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 318.8953488372093,
      y: 313.08139534883725,
    },
    bottomRight: {
      x: 320.93023255813955,
      y: 314.24418604651163,
    },
  },
  {
    id: "837991d8-b587-4a37-aa0a-b4f93d6a2ef3",
    label: "RGB(61,61,61)",
    type: "ImageBox",
    description: "Size: 11 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 310.4651162790698,
      y: 314.8255813953489,
    },
    bottomRight: {
      x: 311.9186046511628,
      y: 316.27906976744185,
    },
  },
  {
    id: "f83a7a37-40a4-43d8-b92a-d0392fc5c69c",
    label: "RGB(53,53,53)",
    type: "ImageBox",
    description: "Size: 46 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 281.6860465116279,
      y: 318.60465116279073,
    },
    bottomRight: {
      x: 284.8837209302326,
      y: 321.22093023255815,
    },
  },
  {
    id: "ac2e2a10-5ffb-41c6-8d69-fa84ffc8161e",
    label: "RGB(65,65,65)",
    type: "ImageBox",
    description: "Size: 52 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 282.2674418604651,
      y: 318.8953488372093,
    },
    bottomRight: {
      x: 284.30232558139534,
      y: 320.93023255813955,
    },
  },
  {
    id: "551f1e7b-f58c-43ca-b1d6-8da27b800856",
    label: "RGB(52,52,52)",
    type: "ImageBox",
    description: "Size: 64 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 277.90697674418607,
      y: 322.9651162790698,
    },
    bottomRight: {
      x: 280.2325581395349,
      y: 325.2906976744186,
    },
  },
  {
    id: "88bb5fa3-5201-4a11-a970-bfec6d1303aa",
    label: "RGB(196,196,196)",
    type: "ImageBox",
    description: "Size: 22 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 274.1279069767442,
      y: 327.90697674418607,
    },
    bottomRight: {
      x: 275.87209302325584,
      y: 329.3604651162791,
    },
  },
  {
    id: "a8d3fbb3-1645-483f-950a-2080e3fe6167",
    label: "RGB(103,103,103)",
    type: "ImageBox",
    description: "Size: 60 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 263.66279069767444,
      y: 333.72093023255815,
    },
    bottomRight: {
      x: 269.7674418604651,
      y: 339.8255813953489,
    },
  },
  {
    id: "383d4b01-11e3-44d4-8e1a-7f3313eb879e",
    label: "RGB(117,117,117)",
    type: "ImageBox",
    description: "Size: 143 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 263.95348837209303,
      y: 334.01162790697674,
    },
    bottomRight: {
      x: 270.93023255813955,
      y: 342.1511627906977,
    },
  },
  {
    id: "57bc76ff-1f8a-451a-9f29-1361b10f328b",
    label: "RGB(129,129,129)",
    type: "ImageBox",
    description: "Size: 128 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 264.5348837209302,
      y: 334.3023255813954,
    },
    bottomRight: {
      x: 271.22093023255815,
      y: 341.5697674418605,
    },
  },
  {
    id: "2e4aa52d-7712-448f-92a4-90a7f1672b80",
    label: "RGB(140,140,140)",
    type: "ImageBox",
    description: "Size: 126 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 265.98837209302326,
      y: 334.8837209302326,
    },
    bottomRight: {
      x: 270.93023255813955,
      y: 340.98837209302326,
    },
  },
  {
    id: "fb82c39a-6416-41bf-9d36-4fc8d466ab6e",
    label: "RGB(53,53,53)",
    type: "ImageBox",
    description: "Size: 40 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 266.27906976744185,
      y: 336.3372093023256,
    },
    bottomRight: {
      x: 268.8953488372093,
      y: 338.95348837209303,
    },
  },
  {
    id: "709e8025-868c-41e8-8848-ba6f076516f5",
    label: "RGB(42,42,42)",
    type: "ImageBox",
    description: "Size: 32 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 266.8604651162791,
      y: 336.6279069767442,
    },
    bottomRight: {
      x: 268.31395348837214,
      y: 338.66279069767444,
    },
  },
  {
    id: "b259f46d-c809-4807-8850-74c729f934df",
    label: "RGB(196,196,196)",
    type: "ImageBox",
    description: "Size: 95 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 359.593023255814,
      y: 338.66279069767444,
    },
    bottomRight: {
      x: 368.31395348837214,
      y: 341.27906976744185,
    },
  },
  {
    id: "b933ea22-59da-4830-895a-31807245db89",
    label: "RGB(207,207,207)",
    type: "ImageBox",
    description: "Size: 79 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 365.1162790697675,
      y: 338.95348837209303,
    },
    bottomRight: {
      x: 370.93023255813955,
      y: 344.7674418604651,
    },
  },
  {
    id: "d216bfc5-b5af-4c6b-8d9a-241fe2bacd72",
    label: "RGB(218,218,218)",
    type: "ImageBox",
    description: "Size: 87 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 368.0232558139535,
      y: 339.5348837209302,
    },
    bottomRight: {
      x: 370.34883720930236,
      y: 347.9651162790698,
    },
  },
  {
    id: "6da85c90-c40f-4053-84c2-cec4d62166aa",
    label: "RGB(214,214,214)",
    type: "ImageBox",
    description: "Size: 20 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 359.593023255814,
      y: 339.8255813953489,
    },
    bottomRight: {
      x: 361.6279069767442,
      y: 341.27906976744185,
    },
  },
  {
    id: "c0ac09c3-dafd-491b-951e-639e0a55b5b3",
    label: "RGB(225,225,225)",
    type: "ImageBox",
    description: "Size: 429 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 357.84883720930236,
      y: 340.1162790697675,
    },
    bottomRight: {
      x: 370.05813953488376,
      y: 351.16279069767444,
    },
  },
  {
    id: "7d33dbfb-efdd-4ba8-a174-c6cf4c694292",
    label: "RGB(60,60,60)",
    type: "ImageBox",
    description: "Size: 126 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 268.60465116279073,
      y: 341.27906976744185,
    },
    bottomRight: {
      x: 274.4186046511628,
      y: 346.22093023255815,
    },
  },
  {
    id: "e01af1f4-8e38-4fab-842b-35871b38bc99",
    label: "RGB(50,50,50)",
    type: "ImageBox",
    description: "Size: 540 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 360.1744186046512,
      y: 341.27906976744185,
    },
    bottomRight: {
      x: 368.0232558139535,
      y: 348.25581395348837,
    },
  },
  {
    id: "f4e3590e-9d0a-4451-bdd9-2e3b9e04c6a8",
    label: "RGB(72,72,72)",
    type: "ImageBox",
    description: "Size: 59 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 268.60465116279073,
      y: 342.4418604651163,
    },
    bottomRight: {
      x: 272.3837209302326,
      y: 345.05813953488376,
    },
  },
  {
    id: "675ce9ca-7944-448c-9938-2c49fb53db44",
    label: "RGB(101,101,101)",
    type: "ImageBox",
    description: "Size: 20 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 266.5697674418605,
      y: 343.0232558139535,
    },
    bottomRight: {
      x: 268.8953488372093,
      y: 345.05813953488376,
    },
  },
  {
    id: "782da507-3d2e-441e-afa6-72eb748c2a60",
    label: "RGB(89,89,89)",
    type: "ImageBox",
    description: "Size: 16 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 257.5581395348837,
      y: 343.31395348837214,
    },
    bottomRight: {
      x: 258.72093023255815,
      y: 345.34883720930236,
    },
  },
  {
    id: "dc244042-37f6-45a8-bc27-da83dff6ddb6",
    label: "RGB(83,83,83)",
    type: "ImageBox",
    description: "Size: 22 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 269.1860465116279,
      y: 343.31395348837214,
    },
    bottomRight: {
      x: 270.63953488372096,
      y: 344.7674418604651,
    },
  },
  {
    id: "a718014e-9b65-4475-895b-15f40f945a48",
    label: "RGB(121,121,121)",
    type: "ImageBox",
    description: "Size: 63 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 258.72093023255815,
      y: 343.60465116279073,
    },
    bottomRight: {
      x: 265.40697674418607,
      y: 345.93023255813955,
    },
  },
  {
    id: "54368de1-b90b-44c4-a478-860cb706a040",
    label: "RGB(138,138,138)",
    type: "ImageBox",
    description: "Size: 134 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 259.30232558139534,
      y: 343.60465116279073,
    },
    bottomRight: {
      x: 268.31395348837214,
      y: 346.8023255813954,
    },
  },
  {
    id: "c3c8edd6-9d0d-41e8-9196-c21f1c362876",
    label: "RGB(154,154,154)",
    type: "ImageBox",
    description: "Size: 30 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 265.69767441860466,
      y: 344.1860465116279,
    },
    bottomRight: {
      x: 267.7325581395349,
      y: 346.22093023255815,
    },
  },
  {
    id: "813f953a-5233-470f-addb-aa73203fd0a0",
    label: "RGB(169,169,169)",
    type: "ImageBox",
    description: "Size: 22 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 265.98837209302326,
      y: 344.4767441860465,
    },
    bottomRight: {
      x: 267.1511627906977,
      y: 345.63953488372096,
    },
  },
  {
    id: "a15d9351-8efc-45df-9776-c30c1e275a57",
    label: "RGB(115,115,115)",
    type: "ImageBox",
    description: "Size: 99 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 265.40697674418607,
      y: 346.51162790697674,
    },
    bottomRight: {
      x: 267.4418604651163,
      y: 354.0697674418605,
    },
  },
  {
    id: "52827d17-1001-4f93-a18a-20542421e64e",
    label: "RGB(236,236,236)",
    type: "ImageBox",
    description: "Size: 24 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 364.8255813953489,
      y: 347.6744186046512,
    },
    bottomRight: {
      x: 368.0232558139535,
      y: 350,
    },
  },
  {
    id: "36af3b5a-3635-4eb0-8c98-0f975771b441",
    label: "RGB(185,185,185)",
    type: "ImageBox",
    description: "Size: 14 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 332.55813953488376,
      y: 348.8372093023256,
    },
    bottomRight: {
      x: 334.01162790697674,
      y: 350.58139534883725,
    },
  },
  {
    id: "77bb562e-a101-4634-8a20-3b4ca28496d5",
    label: "RGB(200,200,200)",
    type: "ImageBox",
    description: "Size: 251 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 332.84883720930236,
      y: 349.4186046511628,
    },
    bottomRight: {
      x: 341.8604651162791,
      y: 363.37209302325584,
    },
  },
  {
    id: "e397bef7-8913-4974-abe0-1fd2ff2ab3f4",
    label: "RGB(254,254,254)",
    type: "ImageBox",
    description: "Size: 75 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 280.2325581395349,
      y: 350,
    },
    bottomRight: {
      x: 282.55813953488376,
      y: 353.19767441860466,
    },
  },
  {
    id: "48f2ee61-599f-46b9-932e-319960fa25f7",
    label: "RGB(236,236,236)",
    type: "ImageBox",
    description: "Size: 280 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 272.3837209302326,
      y: 351.45348837209303,
    },
    bottomRight: {
      x: 281.3953488372093,
      y: 366.8604651162791,
    },
  },
  {
    id: "45924027-6403-41c6-8e2e-e9f8dc328d91",
    label: "RGB(141,141,141)",
    type: "ImageBox",
    description: "Size: 57 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 265.40697674418607,
      y: 352.6162790697675,
    },
    bottomRight: {
      x: 268.0232558139535,
      y: 357.2674418604651,
    },
  },
  {
    id: "5135ffa6-dc39-4926-b4e7-4ccdf42a842f",
    label: "RGB(169,169,169)",
    type: "ImageBox",
    description: "Size: 39 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 264.8255813953489,
      y: 353.19767441860466,
    },
    bottomRight: {
      x: 266.5697674418605,
      y: 355.2325581395349,
    },
  },
  {
    id: "950052f2-899c-475c-a707-8598112783bc",
    label: "RGB(207,207,207)",
    type: "ImageBox",
    description: "Size: 18 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 364.24418604651163,
      y: 353.19767441860466,
    },
    bottomRight: {
      x: 365.69767441860466,
      y: 354.3604651162791,
    },
  },
  {
    id: "62d9cebc-be71-40d2-8260-562c885df13d",
    label: "RGB(218,218,218)",
    type: "ImageBox",
    description: "Size: 273 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 363.66279069767444,
      y: 354.0697674418605,
    },
    bottomRight: {
      x: 366.27906976744185,
      y: 372.6744186046512,
    },
  },
  {
    id: "a9725026-641a-496e-9e45-e714ce0e115c",
    label: "RGB(127,127,127)",
    type: "ImageBox",
    description: "Size: 68 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 261.9186046511628,
      y: 354.3604651162791,
    },
    bottomRight: {
      x: 265.40697674418607,
      y: 358.43023255813955,
    },
  },
  {
    id: "8b160a71-da1d-46af-a713-a0abd42e9b2c",
    label: "RGB(234,234,234)",
    type: "ImageBox",
    description: "Size: 64 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 363.95348837209303,
      y: 354.6511627906977,
    },
    bottomRight: {
      x: 365.98837209302326,
      y: 357.55813953488376,
    },
  },
  {
    id: "55b564f1-8c22-4909-ab36-7d64c0667629",
    label: "RGB(193,193,193)",
    type: "ImageBox",
    description: "Size: 174 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 366.27906976744185,
      y: 355.2325581395349,
    },
    bottomRight: {
      x: 374.7093023255814,
      y: 363.37209302325584,
    },
  },
  {
    id: "396b2e60-296d-44cc-b8c5-cc22fef91839",
    label: "RGB(121,121,121)",
    type: "ImageBox",
    description: "Size: 22 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 266.8604651162791,
      y: 356.10465116279073,
    },
    bottomRight: {
      x: 268.31395348837214,
      y: 358.13953488372096,
    },
  },
  {
    id: "d4eea40d-e39e-498b-86f6-826f112a0a09",
    label: "RGB(164,164,164)",
    type: "ImageBox",
    description: "Size: 13 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 361.3372093023256,
      y: 356.10465116279073,
    },
    bottomRight: {
      x: 363.08139534883725,
      y: 357.55813953488376,
    },
  },
  {
    id: "f402e3b7-3042-4218-9488-2af59175f737",
    label: "RGB(187,187,187)",
    type: "ImageBox",
    description: "Size: 127 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 356.6860465116279,
      y: 356.10465116279073,
    },
    bottomRight: {
      x: 363.37209302325584,
      y: 362.79069767441865,
    },
  },
  {
    id: "2e38bba6-f4ff-4820-b1ce-4cc27e27ec49",
    label: "RGB(69,69,69)",
    type: "ImageBox",
    description: "Size: 35 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 266.5697674418605,
      y: 356.6860465116279,
    },
    bottomRight: {
      x: 269.4767441860465,
      y: 359.8837209302326,
    },
  },
  {
    id: "722c1379-e810-4698-b367-e695b4a7e3ca",
    label: "RGB(88,88,88)",
    type: "ImageBox",
    description: "Size: 32 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 261.04651162790697,
      y: 356.9767441860465,
    },
    bottomRight: {
      x: 263.37209302325584,
      y: 359.8837209302326,
    },
  },
  {
    id: "05412f8b-4544-4389-89f2-1d05815f602c",
    label: "RGB(112,112,112)",
    type: "ImageBox",
    description: "Size: 18 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 261.6279069767442,
      y: 357.2674418604651,
    },
    bottomRight: {
      x: 263.37209302325584,
      y: 359.01162790697674,
    },
  },
  {
    id: "b1c0cd81-3cee-46d5-8759-0c0ab5959ed2",
    label: "RGB(86,86,86)",
    type: "ImageBox",
    description: "Size: 16 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 267.1511627906977,
      y: 357.2674418604651,
    },
    bottomRight: {
      x: 268.8953488372093,
      y: 359.01162790697674,
    },
  },
  {
    id: "3598de79-9f37-4756-92e0-c07e3cb6fa3a",
    label: "RGB(204,204,204)",
    type: "ImageBox",
    description: "Size: 42 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 368.31395348837214,
      y: 357.55813953488376,
    },
    bottomRight: {
      x: 371.8023255813954,
      y: 361.3372093023256,
    },
  },
  {
    id: "2cb57b12-3c53-4d5b-a056-ef0345baae65",
    label: "RGB(68,68,68)",
    type: "ImageBox",
    description: "Size: 23 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 260.75581395348837,
      y: 358.13953488372096,
    },
    bottomRight: {
      x: 263.08139534883725,
      y: 360.4651162790698,
    },
  },
  {
    id: "3ed1d10f-b75d-41f3-a2e6-21ff00f8eaa5",
    label: "RGB(47,47,47)",
    type: "ImageBox",
    description: "Size: 94 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 358.43023255813955,
      y: 360.4651162790698,
    },
    bottomRight: {
      x: 362.5,
      y: 364.24418604651163,
    },
  },
  {
    id: "927fa9db-d64c-4195-842d-80b230424520",
    label: "RGB(216,216,216)",
    type: "ImageBox",
    description: "Size: 147 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 378.7790697674419,
      y: 360.4651162790698,
    },
    bottomRight: {
      x: 385.75581395348837,
      y: 367.7325581395349,
    },
  },
  {
    id: "2b1af7c5-f9cc-4032-bf46-0d02f9c3f4eb",
    label: "RGB(247,247,247)",
    type: "ImageBox",
    description: "Size: 4366 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 203.48837209302326,
      y: 360.75581395348837,
    },
    bottomRight: {
      x: 275.87209302325584,
      y: 488.66279069767444,
    },
  },
  {
    id: "62658fc3-7720-4a33-9908-c66fc7a67a78",
    label: "RGB(198,198,198)",
    type: "ImageBox",
    description: "Size: 38 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 356.10465116279073,
      y: 360.75581395348837,
    },
    bottomRight: {
      x: 359.3023255813954,
      y: 363.66279069767444,
    },
  },
  {
    id: "6c248ecb-a306-49fc-b5fa-8f8a3c5b18c0",
    label: "RGB(228,228,228)",
    type: "ImageBox",
    description: "Size: 50 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 382.84883720930236,
      y: 360.75581395348837,
    },
    bottomRight: {
      x: 387.5,
      y: 362.79069767441865,
    },
  },
  {
    id: "75500d61-5281-4e4f-8748-9ec20c39a41e",
    label: "RGB(239,239,239)",
    type: "ImageBox",
    description: "Size: 85 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 384.3023255813954,
      y: 361.046511627907,
    },
    bottomRight: {
      x: 390.40697674418607,
      y: 363.66279069767444,
    },
  },
  {
    id: "68b6d504-45e8-4880-90fb-f60c1f83e73b",
    label: "RGB(250,250,250)",
    type: "ImageBox",
    description: "Size: 417 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 379.3604651162791,
      y: 361.6279069767442,
    },
    bottomRight: {
      x: 390.69767441860466,
      y: 372.6744186046512,
    },
  },
  {
    id: "83ed8a46-e0e0-42dd-a773-e40915de5d76",
    label: "RGB(124,125,124)",
    type: "ImageBox",
    description: "Size: 21 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 375,
      y: 362.2093023255814,
    },
    bottomRight: {
      x: 377.0348837209303,
      y: 364.5348837209303,
    },
  },
  {
    id: "93136325-7b93-4f56-a6ac-fd1585ad0b06",
    label: "RGB(209,209,209)",
    type: "ImageBox",
    description: "Size: 40 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 355.2325581395349,
      y: 362.5,
    },
    bottomRight: {
      x: 357.2674418604651,
      y: 364.5348837209303,
    },
  },
  {
    id: "44a0cbf9-8e63-4312-a13f-818a809b55b6",
    label: "RGB(176,176,176)",
    type: "ImageBox",
    description: "Size: 20 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 373.546511627907,
      y: 362.5,
    },
    bottomRight: {
      x: 375.58139534883725,
      y: 363.95348837209303,
    },
  },
  {
    id: "bd6f28fc-9896-4f64-ac5f-7672143c29c5",
    label: "RGB(146,146,146)",
    type: "ImageBox",
    description: "Size: 18 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 374.1279069767442,
      y: 362.79069767441865,
    },
    bottomRight: {
      x: 376.45348837209303,
      y: 364.24418604651163,
    },
  },
  {
    id: "818ea9d8-1350-4447-97bc-0eb57518c715",
    label: "RGB(102,102,102)",
    type: "ImageBox",
    description: "Size: 15 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 375.87209302325584,
      y: 362.79069767441865,
    },
    bottomRight: {
      x: 377.3255813953489,
      y: 364.8255813953489,
    },
  },
  {
    id: "e90f48a6-fc46-429f-947d-4e25267255be",
    label: "RGB(62,67,67)",
    type: "ImageBox",
    description: "Size: 18 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 366.27906976744185,
      y: 363.08139534883725,
    },
    bottomRight: {
      x: 367.4418604651163,
      y: 366.8604651162791,
    },
  },
  {
    id: "4885976d-1226-4831-b3cd-b2b077fcdc89",
    label: "RGB(249,245,233)",
    type: "ImageBox",
    description: "Size: 28 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 340.69767441860466,
      y: 363.37209302325584,
    },
    bottomRight: {
      x: 343.0232558139535,
      y: 364.5348837209303,
    },
  },
  {
    id: "60b9d891-e1c3-454b-8ff4-90312f7931ba",
    label: "RGB(182,182,182)",
    type: "ImageBox",
    description: "Size: 11 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 354.9418604651163,
      y: 363.37209302325584,
    },
    bottomRight: {
      x: 356.3953488372093,
      y: 364.8255813953489,
    },
  },
  {
    id: "8f05571a-47c1-4fa3-adff-b342bf89027a",
    label: "RGB(87,87,87)",
    type: "ImageBox",
    description: "Size: 16 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 377.0348837209303,
      y: 363.37209302325584,
    },
    bottomRight: {
      x: 378.19767441860466,
      y: 365.40697674418607,
    },
  },
  {
    id: "4d1e451b-dc19-4e69-aeaa-90abcdd6dfb1",
    label: "RGB(41,41,41)",
    type: "ImageBox",
    description: "Size: 242 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 381.3953488372093,
      y: 363.37209302325584,
    },
    bottomRight: {
      x: 387.2093023255814,
      y: 370.05813953488376,
    },
  },
  {
    id: "ad1d036a-1a87-4e5d-b6a7-6d7ca9b6d5bd",
    label: "RGB(148,239,249)",
    type: "ImageBox",
    description: "Size: 17 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 361.6279069767442,
      y: 363.95348837209303,
    },
    bottomRight: {
      x: 362.79069767441865,
      y: 365.1162790697675,
    },
  },
  {
    id: "3e9858eb-0789-4a1c-b809-3fcb15fdbeb1",
    label: "RGB(184,255,175)",
    type: "ImageBox",
    description: "Size: 26 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 253.48837209302326,
      y: 364.24418604651163,
    },
    bottomRight: {
      x: 255.5232558139535,
      y: 365.98837209302326,
    },
  },
  {
    id: "2fbdfbe8-205b-42d5-ab75-22008cabfa8f",
    label: "RGB(227,227,227)",
    type: "ImageBox",
    description: "Size: 24 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 378.48837209302326,
      y: 365.1162790697675,
    },
    bottomRight: {
      x: 379.9418604651163,
      y: 367.4418604651163,
    },
  },
  {
    id: "c169ed28-a9c7-4943-8263-2c276ebb820c",
    label: "RGB(64,65,63)",
    type: "ImageBox",
    description: "Size: 19 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 361.3372093023256,
      y: 366.5697674418605,
    },
    bottomRight: {
      x: 362.79069767441865,
      y: 370.34883720930236,
    },
  },
  {
    id: "f9c16dc9-e39a-4bca-b70f-3e60d71901d3",
    label: "RGB(238,238,238)",
    type: "ImageBox",
    description: "Size: 20 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 378.48837209302326,
      y: 366.5697674418605,
    },
    bottomRight: {
      x: 380.2325581395349,
      y: 367.7325581395349,
    },
  },
  {
    id: "7f4f2990-c15c-4500-ae94-1203815cc617",
    label: "RGB(206,208,208)",
    type: "ImageBox",
    description: "Size: 41 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 343.31395348837214,
      y: 367.1511627906977,
    },
    bottomRight: {
      x: 345.93023255813955,
      y: 369.4767441860465,
    },
  },
  {
    id: "e7679074-c7b1-440a-a8a4-89abdc6fd587",
    label: "RGB(232,232,232)",
    type: "ImageBox",
    description: "Size: 50 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 378.48837209302326,
      y: 368.60465116279073,
    },
    bottomRight: {
      x: 380.2325581395349,
      y: 372.3837209302326,
    },
  },
  {
    id: "407d2e0e-e8a6-4414-9675-6a501debc394",
    label: "RGB(157,248,246)",
    type: "ImageBox",
    description: "Size: 33 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 368.60465116279073,
      y: 369.1860465116279,
    },
    bottomRight: {
      x: 371.22093023255815,
      y: 370.34883720930236,
    },
  },
  {
    id: "22d0009f-07be-478d-ad16-e639fbe38c04",
    label: "RGB(177,246,170)",
    type: "ImageBox",
    description: "Size: 33 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 259.01162790697674,
      y: 369.4767441860465,
    },
    bottomRight: {
      x: 261.3372093023256,
      y: 370.93023255813955,
    },
  },
  {
    id: "9b9c5b33-8d48-4d66-92eb-40aefa6e9427",
    label: "RGB(231,231,231)",
    type: "ImageBox",
    description: "Size: 40 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 364.24418604651163,
      y: 369.7674418604651,
    },
    bottomRight: {
      x: 365.69767441860466,
      y: 372.093023255814,
    },
  },
  {
    id: "25a47952-e49d-4977-a337-1ec15650688c",
    label: "RGB(224,222,215)",
    type: "ImageBox",
    description: "Size: 32 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 345.93023255813955,
      y: 370.93023255813955,
    },
    bottomRight: {
      x: 347.6744186046512,
      y: 373.25581395348837,
    },
  },
  {
    id: "e8c138c0-7624-492f-916d-e930608924e1",
    label: "RGB(224,224,224)",
    type: "ImageBox",
    description: "Size: 24 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 382.55813953488376,
      y: 371.8023255813954,
    },
    bottomRight: {
      x: 387.2093023255814,
      y: 373.25581395348837,
    },
  },
  {
    id: "a5334b9b-8308-4b13-bc17-fb8192e8e55f",
    label: "RGB(143,143,143)",
    type: "ImageBox",
    description: "Size: 56 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 365.98837209302326,
      y: 372.6744186046512,
    },
    bottomRight: {
      x: 369.4767441860465,
      y: 377.0348837209303,
    },
  },
  {
    id: "2278a787-1a7a-4e7f-b61a-3479255d05c7",
    label: "RGB(165,165,165)",
    type: "ImageBox",
    description: "Size: 10 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 363.08139534883725,
      y: 373.25581395348837,
    },
    bottomRight: {
      x: 364.5348837209303,
      y: 374.4186046511628,
    },
  },
  {
    id: "b5f83654-ffa1-42a6-9977-77fd3805e424",
    label: "RGB(69,69,69)",
    type: "ImageBox",
    description: "Size: 12 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 386.9186046511628,
      y: 373.546511627907,
    },
    bottomRight: {
      x: 388.95348837209303,
      y: 374.7093023255814,
    },
  },
  {
    id: "605d5d9d-7a8b-4be2-8b7b-11d0861f0b85",
    label: "RGB(229,227,224)",
    type: "ImageBox",
    description: "Size: 209 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 347.093023255814,
      y: 373.8372093023256,
    },
    bottomRight: {
      x: 356.10465116279073,
      y: 387.2093023255814,
    },
  },
  {
    id: "e964b843-3570-48b8-9844-25728e22469c",
    label: "RGB(207,206,206)",
    type: "ImageBox",
    description: "Size: 21 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 348.546511627907,
      y: 373.8372093023256,
    },
    bottomRight: {
      x: 350.29069767441865,
      y: 377.0348837209303,
    },
  },
  {
    id: "f82423b4-2b33-4a23-acb3-4f317de46634",
    label: "RGB(214,214,214)",
    type: "ImageBox",
    description: "Size: 21 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 347.3837209302326,
      y: 374.7093023255814,
    },
    bottomRight: {
      x: 349.1279069767442,
      y: 377.90697674418607,
    },
  },
  {
    id: "b830ca35-42e7-4f42-b85a-05fecff68c99",
    label: "RGB(148,152,148)",
    type: "ImageBox",
    description: "Size: 64 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 360.75581395348837,
      y: 375.29069767441865,
    },
    bottomRight: {
      x: 363.37209302325584,
      y: 379.3604651162791,
    },
  },
  {
    id: "7569e68d-165b-4ed5-9d57-104705f42a9e",
    label: "RGB(156,156,156)",
    type: "ImageBox",
    description: "Size: 40 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 368.31395348837214,
      y: 375.29069767441865,
    },
    bottomRight: {
      x: 370.34883720930236,
      y: 378.48837209302326,
    },
  },
  {
    id: "c7c71bc8-dcfc-4ccc-b4aa-e9c4749d4942",
    label: "RGB(255,233,175)",
    type: "ImageBox",
    description: "Size: 34 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 315.1162790697675,
      y: 376.74418604651163,
    },
    bottomRight: {
      x: 318.31395348837214,
      y: 377.90697674418607,
    },
  },
  {
    id: "478ff9ba-612b-47c7-b981-f8db9ff7418d",
    label: "RGB(168,168,168)",
    type: "ImageBox",
    description: "Size: 105 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 369.1860465116279,
      y: 376.74418604651163,
    },
    bottomRight: {
      x: 373.8372093023256,
      y: 383.72093023255815,
    },
  },
  {
    id: "4c685233-a398-4e85-a58c-13328e6ed3c2",
    label: "RGB(177,247,170)",
    type: "ImageBox",
    description: "Size: 30 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 345.63953488372096,
      y: 377.3255813953489,
    },
    bottomRight: {
      x: 347.6744186046512,
      y: 378.48837209302326,
    },
  },
  {
    id: "bbe6ac85-411e-4d30-af9b-1117735db0b4",
    label: "RGB(206,206,206)",
    type: "ImageBox",
    description: "Size: 12 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 350.58139534883725,
      y: 377.3255813953489,
    },
    bottomRight: {
      x: 351.74418604651163,
      y: 379.3604651162791,
    },
  },
  {
    id: "aa72e0e0-9529-49a3-b28c-7fcb225176cb",
    label: "RGB(148,238,250)",
    type: "ImageBox",
    description: "Size: 31 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 249.7093023255814,
      y: 378.7790697674419,
    },
    bottomRight: {
      x: 252.61627906976744,
      y: 379.9418604651163,
    },
  },
  {
    id: "0a2672bc-3503-42e8-bb67-d74b468557f3",
    label: "RGB(148,239,250)",
    type: "ImageBox",
    description: "Size: 33 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 381.10465116279073,
      y: 378.7790697674419,
    },
    bottomRight: {
      x: 384.3023255813954,
      y: 379.9418604651163,
    },
  },
  {
    id: "7cdba876-d96a-4d8c-b0df-2d8f5049bfe3",
    label: "RGB(179,179,179)",
    type: "ImageBox",
    description: "Size: 47 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 370.34883720930236,
      y: 379.3604651162791,
    },
    bottomRight: {
      x: 372.9651162790698,
      y: 382.84883720930236,
    },
  },
  {
    id: "93bfb8df-5d7f-4aa3-928b-c432c84c80b6",
    label: "RGB(176,245,169)",
    type: "ImageBox",
    description: "Size: 29 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 258.43023255813955,
      y: 379.6511627906977,
    },
    bottomRight: {
      x: 260.4651162790698,
      y: 380.81395348837214,
    },
  },
  {
    id: "9b7fc796-c3f9-44f4-a812-0770a261e6f9",
    label: "RGB(151,242,253)",
    type: "ImageBox",
    description: "Size: 24 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 334.3023255813954,
      y: 381.9767441860465,
    },
    bottomRight: {
      x: 336.046511627907,
      y: 383.13953488372096,
    },
  },
  {
    id: "feda785f-8ab9-4ffa-b5ef-cda4bf59d7a1",
    label: "RGB(147,237,247)",
    type: "ImageBox",
    description: "Size: 45 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 355.5232558139535,
      y: 382.55813953488376,
    },
    bottomRight: {
      x: 358.13953488372096,
      y: 384.3023255813954,
    },
  },
  {
    id: "b8e56d20-1529-45a8-a40b-15cb25551fda",
    label: "RGB(147,240,251)",
    type: "ImageBox",
    description: "Size: 37 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 375.87209302325584,
      y: 382.55813953488376,
    },
    bottomRight: {
      x: 378.48837209302326,
      y: 383.72093023255815,
    },
  },
  {
    id: "0a6f4907-48a6-43cc-9c82-3c5cd5a6b97f",
    label: "RGB(139,139,139)",
    type: "ImageBox",
    description: "Size: 11 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 372.9651162790698,
      y: 382.84883720930236,
    },
    bottomRight: {
      x: 374.1279069767442,
      y: 384.3023255813954,
    },
  },
  {
    id: "4f5f7d05-706a-4804-9e01-57b037121d09",
    label: "RGB(117,117,117)",
    type: "ImageBox",
    description: "Size: 12 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 372.9651162790698,
      y: 382.84883720930236,
    },
    bottomRight: {
      x: 374.4186046511628,
      y: 384.593023255814,
    },
  },
  {
    id: "9bb7d8c7-d674-4dd1-a5a5-8500ab89f6df",
    label: "RGB(181,252,173)",
    type: "ImageBox",
    description: "Size: 53 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 234.30232558139537,
      y: 384.3023255813954,
    },
    bottomRight: {
      x: 236.9186046511628,
      y: 386.6279069767442,
    },
  },
  {
    id: "b77e0bfd-a3c6-4a31-bbd9-6b78e91b451d",
    label: "RGB(182,253,175)",
    type: "ImageBox",
    description: "Size: 50 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 362.79069767441865,
      y: 384.8837209302326,
    },
    bottomRight: {
      x: 366.27906976744185,
      y: 387.2093023255814,
    },
  },
  {
    id: "00ae8852-bfc7-425c-82a6-7eeb91e51193",
    label: "RGB(185,255,176)",
    type: "ImageBox",
    description: "Size: 21 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 225.58139534883722,
      y: 387.2093023255814,
    },
    bottomRight: {
      x: 227.32558139534885,
      y: 388.37209302325584,
    },
  },
  {
    id: "661bbcee-4ab1-4014-9f85-322e84f8b3b7",
    label: "RGB(238,248,250)",
    type: "ImageBox",
    description: "Size: 29 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 354.9418604651163,
      y: 387.2093023255814,
    },
    bottomRight: {
      x: 356.9767441860465,
      y: 388.37209302325584,
    },
  },
  {
    id: "b2278885-76a9-46d2-a588-412af76966c3",
    label: "RGB(221,227,228)",
    type: "ImageBox",
    description: "Size: 98 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 355.2325581395349,
      y: 388.37209302325584,
    },
    bottomRight: {
      x: 359.8837209302326,
      y: 393.0232558139535,
    },
  },
  {
    id: "4af21f09-6706-41a4-84c8-4f1d94b35f9f",
    label: "RGB(179,250,173)",
    type: "ImageBox",
    description: "Size: 45 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 185.17441860465118,
      y: 421.8023255813954,
    },
    bottomRight: {
      x: 188.08139534883722,
      y: 423.546511627907,
    },
  },
  {
    id: "f8028562-69b6-40db-ada2-32e297372998",
    label: "RGB(184,255,176)",
    type: "ImageBox",
    description: "Size: 49 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 266.8604651162791,
      y: 421.8023255813954,
    },
    bottomRight: {
      x: 269.7674418604651,
      y: 423.25581395348837,
    },
  },
  {
    id: "fc3e9150-d779-479f-ab62-077d1bfd8327",
    label: "RGB(149,240,250)",
    type: "ImageBox",
    description: "Size: 29 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 236.046511627907,
      y: 422.6744186046512,
    },
    bottomRight: {
      x: 238.37209302325581,
      y: 423.8372093023256,
    },
  },
  {
    id: "382c9575-8d85-4416-a0ab-68e34f936a50",
    label: "RGB(147,237,247)",
    type: "ImageBox",
    description: "Size: 107 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 327.6162790697675,
      y: 422.6744186046512,
    },
    bottomRight: {
      x: 333.43023255813955,
      y: 425.58139534883725,
    },
  },
  {
    id: "b95c5bf8-e9f5-4c9d-96fe-e114d95268d9",
    label: "RGB(151,243,254)",
    type: "ImageBox",
    description: "Size: 52 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 194.76744186046514,
      y: 423.546511627907,
    },
    bottomRight: {
      x: 198.25581395348837,
      y: 425.29069767441865,
    },
  },
  {
    id: "7e241c22-d0d0-4348-80a8-e5a538401ce5",
    label: "RGB(244,244,244)",
    type: "ImageBox",
    description: "Size: 35 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 377.6162790697675,
      y: 424.4186046511628,
    },
    bottomRight: {
      x: 379.6511627906977,
      y: 427.0348837209303,
    },
  },
  {
    id: "18af431d-f178-47da-8ebd-9076c8ea16b1",
    label: "RGB(252,229,172)",
    type: "ImageBox",
    description: "Size: 111 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 302.0348837209302,
      y: 425,
    },
    bottomRight: {
      x: 306.6860465116279,
      y: 427.90697674418607,
    },
  },
  {
    id: "2889425e-39b6-4049-ac58-6921edf7ef13",
    label: "RGB(147,237,247)",
    type: "ImageBox",
    description: "Size: 109 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 313.08139534883725,
      y: 425,
    },
    bottomRight: {
      x: 320.63953488372096,
      y: 426.74418604651163,
    },
  },
  {
    id: "998a6e50-7a7e-48a9-860f-65063d771004",
    label: "RGB(241,241,241)",
    type: "ImageBox",
    description: "Size: 47 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 151.16279069767444,
      y: 425.87209302325584,
    },
    bottomRight: {
      x: 156.3953488372093,
      y: 427.6162790697675,
    },
  },
  {
    id: "816c129e-e97d-4971-b9e4-3a2d88ca8f8b",
    label: "RGB(252,252,252)",
    type: "ImageBox",
    description: "Size: 3122 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 136.3372093023256,
      y: 426.16279069767444,
    },
    bottomRight: {
      x: 170.05813953488374,
      y: 466.5697674418605,
    },
  },
  {
    id: "0a0f8412-085d-4b5b-a5a6-df1608e463df",
    label: "RGB(180,249,172)",
    type: "ImageBox",
    description: "Size: 44 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 220.93023255813955,
      y: 426.16279069767444,
    },
    bottomRight: {
      x: 224.12790697674419,
      y: 427.3255813953489,
    },
  },
  {
    id: "3238c414-eaa4-48aa-9aae-a3d827ebdfd8",
    label: "RGB(183,255,176)",
    type: "ImageBox",
    description: "Size: 17 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 342.1511627906977,
      y: 426.16279069767444,
    },
    bottomRight: {
      x: 343.8953488372093,
      y: 427.3255813953489,
    },
  },
  {
    id: "2610aa1f-284f-43e7-b801-dab53c4a76d6",
    label: "RGB(152,244,255)",
    type: "ImageBox",
    description: "Size: 45 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 434.593023255814,
      y: 426.16279069767444,
    },
    bottomRight: {
      x: 438.37209302325584,
      y: 427.3255813953489,
    },
  },
  {
    id: "796620bb-e5d4-4f82-a4af-bcaecf806ce2",
    label: "RGB(145,232,242)",
    type: "ImageBox",
    description: "Size: 15 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 367.1511627906977,
      y: 426.45348837209303,
    },
    bottomRight: {
      x: 368.31395348837214,
      y: 428.48837209302326,
    },
  },
  {
    id: "64586411-a238-4373-a07d-2ccb999a8e9f",
    label: "RGB(148,238,250)",
    type: "ImageBox",
    description: "Size: 80 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 417.4418604651163,
      y: 426.45348837209303,
    },
    bottomRight: {
      x: 423.8372093023256,
      y: 427.90697674418607,
    },
  },
  {
    id: "1f9af8c2-9c70-43bb-804c-f8255585dd1d",
    label: "RGB(153,247,253)",
    type: "ImageBox",
    description: "Size: 47 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 340.40697674418607,
      y: 427.0348837209303,
    },
    bottomRight: {
      x: 343.0232558139535,
      y: 428.7790697674419,
    },
  },
  {
    id: "66e473c0-3607-4b6e-8df5-c5f5ff491233",
    label: "RGB(182,253,176)",
    type: "ImageBox",
    description: "Size: 21 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 370.34883720930236,
      y: 427.0348837209303,
    },
    bottomRight: {
      x: 372.093023255814,
      y: 428.19767441860466,
    },
  },
  {
    id: "5649b8ae-fc70-4cab-80c4-e0908e2c3083",
    label: "RGB(250,230,172)",
    type: "ImageBox",
    description: "Size: 33 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 208.43023255813955,
      y: 427.3255813953489,
    },
    bottomRight: {
      x: 211.62790697674419,
      y: 428.48837209302326,
    },
  },
  {
    id: "b1f12126-9ee5-4724-8513-523b1c80ccea",
    label: "RGB(149,242,253)",
    type: "ImageBox",
    description: "Size: 59 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 367.1511627906977,
      y: 427.3255813953489,
    },
    bottomRight: {
      x: 370.34883720930236,
      y: 429.0697674418605,
    },
  },
  {
    id: "b7568480-3f3a-4674-b98c-99ca54e9896c",
    label: "RGB(247,241,177)",
    type: "ImageBox",
    description: "Size: 76 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 325,
      y: 427.90697674418607,
    },
    bottomRight: {
      x: 328.77906976744185,
      y: 429.9418604651163,
    },
  },
  {
    id: "4977d55c-cac0-4009-bb94-23c6d9fcc322",
    label: "RGB(244,244,244)",
    type: "ImageBox",
    description: "Size: 745 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 379.9418604651163,
      y: 428.19767441860466,
    },
    bottomRight: {
      x: 401.16279069767444,
      y: 462.2093023255814,
    },
  },
  {
    id: "bd665087-2e27-4091-ace4-3283a3e50b97",
    label: "RGB(190,249,184)",
    type: "ImageBox",
    description: "Size: 22 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 239.53488372093025,
      y: 428.48837209302326,
    },
    bottomRight: {
      x: 241.56976744186048,
      y: 429.6511627906977,
    },
  },
  {
    id: "38a21954-aaef-4946-bb50-739dbe22f57c",
    label: "RGB(252,230,172)",
    type: "ImageBox",
    description: "Size: 76 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 281.9767441860465,
      y: 428.48837209302326,
    },
    bottomRight: {
      x: 286.6279069767442,
      y: 429.9418604651163,
    },
  },
  {
    id: "b637076b-5130-4abd-a554-6fa0f1dbc6e5",
    label: "RGB(249,227,170)",
    type: "ImageBox",
    description: "Size: 48 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 440.40697674418607,
      y: 428.48837209302326,
    },
    bottomRight: {
      x: 444.4767441860465,
      y: 429.6511627906977,
    },
  },
  {
    id: "83c7aa4e-162c-4b31-a2c2-2b6b52eabd58",
    label: "RGB(47,47,47)",
    type: "ImageBox",
    description: "Size: 7798 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 139.53488372093025,
      y: 429.3604651162791,
    },
    bottomRight: {
      x: 166.56976744186048,
      y: 463.08139534883725,
    },
  },
  {
    id: "8c55f45d-bda9-4d51-a289-07e6c769c1ef",
    label: "RGB(150,240,251)",
    type: "ImageBox",
    description: "Size: 75 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 184.01162790697674,
      y: 429.3604651162791,
    },
    bottomRight: {
      x: 186.9186046511628,
      y: 431.9767441860465,
    },
  },
  {
    id: "af1d6cb2-d09f-4434-ae68-ac73b352dbdb",
    label: "RGB(177,247,171)",
    type: "ImageBox",
    description: "Size: 50 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 266.27906976744185,
      y: 429.9418604651163,
    },
    bottomRight: {
      x: 270.05813953488376,
      y: 431.10465116279073,
    },
  },
  {
    id: "f8a9a35d-5132-4708-b675-6828c76f9c62",
    label: "RGB(148,238,250)",
    type: "ImageBox",
    description: "Size: 82 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 299.1279069767442,
      y: 430.2325581395349,
    },
    bottomRight: {
      x: 303.77906976744185,
      y: 432.55813953488376,
    },
  },
  {
    id: "a9f73289-10a4-4309-a76f-b3285c126add",
    label: "RGB(148,239,250)",
    type: "ImageBox",
    description: "Size: 52 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 174.7093023255814,
      y: 430.81395348837214,
    },
    bottomRight: {
      x: 178.19767441860466,
      y: 431.9767441860465,
    },
  },
  {
    id: "2a5dbfb7-1ec5-4093-84cb-9ab83ae4c817",
    label: "RGB(255,237,177)",
    type: "ImageBox",
    description: "Size: 57 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 421.8023255813954,
      y: 430.81395348837214,
    },
    bottomRight: {
      x: 424.4186046511628,
      y: 432.55813953488376,
    },
  },
  {
    id: "e99391bd-f32d-4363-9c40-c39268965d01",
    label: "RGB(230,230,230)",
    type: "ImageBox",
    description: "Size: 28 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 149.7093023255814,
      y: 431.10465116279073,
    },
    bottomRight: {
      x: 152.03488372093025,
      y: 432.84883720930236,
    },
  },
  {
    id: "bc783079-d1f3-4a14-abee-b7ccf6dad5f5",
    label: "RGB(150,244,255)",
    type: "ImageBox",
    description: "Size: 27 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 244.47674418604652,
      y: 431.3953488372093,
    },
    bottomRight: {
      x: 246.51162790697677,
      y: 432.55813953488376,
    },
  },
  {
    id: "5f2dcb8b-3a7b-4a92-8529-128e4cfe32f1",
    label: "RGB(182,253,174)",
    type: "ImageBox",
    description: "Size: 46 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 250.00000000000003,
      y: 431.3953488372093,
    },
    bottomRight: {
      x: 252.61627906976744,
      y: 433.13953488372096,
    },
  },
  {
    id: "5b79fba1-0389-4a71-ba16-8c0d4d6bd241",
    label: "RGB(186,186,186)",
    type: "ImageBox",
    description: "Size: 14 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 148.8372093023256,
      y: 431.6860465116279,
    },
    bottomRight: {
      x: 150.58139534883722,
      y: 433.43023255813955,
    },
  },
  {
    id: "1d313740-79e2-46d1-9cab-b8c2b8a5266b",
    label: "RGB(181,252,173)",
    type: "ImageBox",
    description: "Size: 66 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 285.75581395348837,
      y: 431.6860465116279,
    },
    bottomRight: {
      x: 288.95348837209303,
      y: 433.43023255813955,
    },
  },
  {
    id: "d05c6202-df7f-4132-8073-516d1c7c8ff1",
    label: "RGB(178,247,171)",
    type: "ImageBox",
    description: "Size: 53 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 305.81395348837214,
      y: 432.26744186046517,
    },
    bottomRight: {
      x: 308.72093023255815,
      y: 434.01162790697674,
    },
  },
  {
    id: "0fe59a2f-7d38-4260-b362-77d98b429f04",
    label: "RGB(180,250,173)",
    type: "ImageBox",
    description: "Size: 49 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 223.25581395348837,
      y: 432.84883720930236,
    },
    bottomRight: {
      x: 226.74418604651163,
      y: 434.3023255813954,
    },
  },
  {
    id: "d4b68375-e902-4e20-9684-41b8d5c392a4",
    label: "RGB(150,241,251)",
    type: "ImageBox",
    description: "Size: 37 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 354.6511627906977,
      y: 433.43023255813955,
    },
    bottomRight: {
      x: 357.2674418604651,
      y: 434.593023255814,
    },
  },
  {
    id: "ed4447da-d6ee-4587-8cde-8a4796eb6007",
    label: "RGB(255,236,176)",
    type: "ImageBox",
    description: "Size: 48 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 218.3139534883721,
      y: 433.72093023255815,
    },
    bottomRight: {
      x: 222.67441860465118,
      y: 434.8837209302326,
    },
  },
  {
    id: "a7b0a364-3b20-4c17-83aa-73af28d60b7d",
    label: "RGB(254,236,178)",
    type: "ImageBox",
    description: "Size: 55 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 357.84883720930236,
      y: 433.72093023255815,
    },
    bottomRight: {
      x: 359.8837209302326,
      y: 436.3372093023256,
    },
  },
  {
    id: "89d4bb16-4062-42e0-b81d-cc7e4852087d",
    label: "RGB(178,245,169)",
    type: "ImageBox",
    description: "Size: 41 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 423.546511627907,
      y: 434.01162790697674,
    },
    bottomRight: {
      x: 426.45348837209303,
      y: 435.1744186046512,
    },
  },
  {
    id: "2ca5bf23-51e3-4ee1-893b-8835897a52cb",
    label: "RGB(255,237,177)",
    type: "ImageBox",
    description: "Size: 78 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 321.8023255813954,
      y: 434.593023255814,
    },
    bottomRight: {
      x: 326.16279069767444,
      y: 436.9186046511628,
    },
  },
  {
    id: "b144e946-2dc6-4d2d-8f8b-b3bdab6779e6",
    label: "RGB(255,235,175)",
    type: "ImageBox",
    description: "Size: 78 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 340.69767441860466,
      y: 434.593023255814,
    },
    bottomRight: {
      x: 343.0232558139535,
      y: 437.5,
    },
  },
  {
    id: "326483d8-cdcb-46d2-9c96-c77b5f9ce290",
    label: "RGB(252,232,173)",
    type: "ImageBox",
    description: "Size: 81 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 301.16279069767444,
      y: 435.4651162790698,
    },
    bottomRight: {
      x: 305.2325581395349,
      y: 437.2093023255814,
    },
  },
  {
    id: "4731ce1c-ab49-4454-8326-35adf7fe4bb7",
    label: "RGB(250,228,171)",
    type: "ImageBox",
    description: "Size: 12 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 229.9418604651163,
      y: 436.046511627907,
    },
    bottomRight: {
      x: 231.1046511627907,
      y: 437.2093023255814,
    },
  },
  {
    id: "36a49bc6-0bc3-4da4-a664-c2462bd36144",
    label: "RGB(252,230,173)",
    type: "ImageBox",
    description: "Size: 50 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 367.1511627906977,
      y: 436.9186046511628,
    },
    bottomRight: {
      x: 369.7674418604651,
      y: 438.37209302325584,
    },
  },
  {
    id: "0354265e-d6dd-4909-acd9-236439959a35",
    label: "RGB(179,250,172)",
    type: "ImageBox",
    description: "Size: 31 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 444.76744186046517,
      y: 437.5,
    },
    bottomRight: {
      x: 447.3837209302326,
      y: 438.66279069767444,
    },
  },
  {
    id: "504e3bff-a03e-4248-b2e5-ebe417af02d6",
    label: "RGB(153,245,255)",
    type: "ImageBox",
    description: "Size: 105 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 175.29069767441862,
      y: 438.37209302325584,
    },
    bottomRight: {
      x: 180.5232558139535,
      y: 442.1511627906977,
    },
  },
  {
    id: "f6e04bec-5392-4165-a812-96d10d356446",
    label: "RGB(181,255,176)",
    type: "ImageBox",
    description: "Size: 60 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 295.34883720930236,
      y: 438.37209302325584,
    },
    bottomRight: {
      x: 299.1279069767442,
      y: 440.1162790697675,
    },
  },
  {
    id: "834821d9-ae1a-4197-938e-a1939dac857b",
    label: "RGB(181,255,176)",
    type: "ImageBox",
    description: "Size: 41 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 327.6162790697675,
      y: 438.37209302325584,
    },
    bottomRight: {
      x: 330.81395348837214,
      y: 439.5348837209303,
    },
  },
  {
    id: "b80dcbba-7b45-45f2-81f8-50e600dafa94",
    label: "RGB(182,253,175)",
    type: "ImageBox",
    description: "Size: 79 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 350.58139534883725,
      y: 438.95348837209303,
    },
    bottomRight: {
      x: 354.0697674418605,
      y: 440.98837209302326,
    },
  },
  {
    id: "cab6a652-ca66-410f-8c38-a4afac09b4bd",
    label: "RGB(253,231,173)",
    type: "ImageBox",
    description: "Size: 119 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 403.48837209302326,
      y: 439.24418604651163,
    },
    bottomRight: {
      x: 408.13953488372096,
      y: 442.4418604651163,
    },
  },
  {
    id: "57d9aec0-533c-4c45-af8f-37c7584a9999",
    label: "RGB(149,240,251)",
    type: "ImageBox",
    description: "Size: 46 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 197.09302325581396,
      y: 439.5348837209303,
    },
    bottomRight: {
      x: 200.29069767441862,
      y: 440.98837209302326,
    },
  },
  {
    id: "f435f774-938d-4985-ade1-e8b026ff4dc4",
    label: "RGB(149,240,251)",
    type: "ImageBox",
    description: "Size: 78 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 451.74418604651163,
      y: 439.5348837209303,
    },
    bottomRight: {
      x: 456.10465116279073,
      y: 440.98837209302326,
    },
  },
  {
    id: "aa0f3114-0073-412a-8a2b-1b70f2c1abfb",
    label: "RGB(149,242,253)",
    type: "ImageBox",
    description: "Size: 61 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 259.593023255814,
      y: 439.8255813953489,
    },
    bottomRight: {
      x: 264.24418604651163,
      y: 440.98837209302326,
    },
  },
  {
    id: "0d3f4296-80bc-43bb-a6a2-336baf8af414",
    label: "RGB(183,254,175)",
    type: "ImageBox",
    description: "Size: 57 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 392.1511627906977,
      y: 440.98837209302326,
    },
    bottomRight: {
      x: 395.63953488372096,
      y: 442.4418604651163,
    },
  },
  {
    id: "c843b49a-8db9-4446-8ceb-f0b87ecfbcf7",
    label: "RGB(179,249,173)",
    type: "ImageBox",
    description: "Size: 65 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 257.5581395348837,
      y: 441.8604651162791,
    },
    bottomRight: {
      x: 262.5,
      y: 443.02325581395354,
    },
  },
  {
    id: "a096b766-6344-4cad-8693-3b83721893ac",
    label: "RGB(181,255,174)",
    type: "ImageBox",
    description: "Size: 73 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 236.6279069767442,
      y: 442.1511627906977,
    },
    bottomRight: {
      x: 239.82558139534885,
      y: 445.05813953488376,
    },
  },
  {
    id: "697a1fd2-013d-4bbe-b6f8-73d363222f90",
    label: "RGB(247,227,170)",
    type: "ImageBox",
    description: "Size: 165 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 371.51162790697674,
      y: 443.31395348837214,
    },
    bottomRight: {
      x: 375.87209302325584,
      y: 447.9651162790698,
    },
  },
  {
    id: "8fc2e67d-9ded-47ff-a7f7-5584146cf3de",
    label: "RGB(249,240,176)",
    type: "ImageBox",
    description: "Size: 71 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 424.1279069767442,
      y: 443.31395348837214,
    },
    bottomRight: {
      x: 427.6162790697675,
      y: 445.05813953488376,
    },
  },
  {
    id: "c88926fd-13b2-47bd-bdda-9b3661c2c2af",
    label: "RGB(255,234,175)",
    type: "ImageBox",
    description: "Size: 34 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 435.75581395348837,
      y: 443.31395348837214,
    },
    bottomRight: {
      x: 438.08139534883725,
      y: 444.4767441860465,
    },
  },
  {
    id: "ab2c3baf-103a-4364-9b43-39d320ff9c01",
    label: "RGB(182,252,174)",
    type: "ImageBox",
    description: "Size: 41 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 313.37209302325584,
      y: 443.60465116279073,
    },
    bottomRight: {
      x: 315.69767441860466,
      y: 445.05813953488376,
    },
  },
  {
    id: "dda2f6c5-f119-4289-8eef-2c48ab8d2f6f",
    label: "RGB(184,255,175)",
    type: "ImageBox",
    description: "Size: 36 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 281.6860465116279,
      y: 444.1860465116279,
    },
    bottomRight: {
      x: 284.30232558139534,
      y: 445.34883720930236,
    },
  },
  {
    id: "44f37247-e8ae-4c0c-8b92-b80ea2eb1890",
    label: "RGB(151,242,252)",
    type: "ImageBox",
    description: "Size: 49 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 380.2325581395349,
      y: 444.1860465116279,
    },
    bottomRight: {
      x: 384.01162790697674,
      y: 445.34883720930236,
    },
  },
  {
    id: "6d89f227-5924-45ac-9002-b4b66275a9f8",
    label: "RGB(181,252,174)",
    type: "ImageBox",
    description: "Size: 66 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 444.76744186046517,
      y: 444.1860465116279,
    },
    bottomRight: {
      x: 450.29069767441865,
      y: 445.63953488372096,
    },
  },
  {
    id: "f45ec50e-ebc9-4e4d-a69a-c3653c0e87e8",
    label: "RGB(254,232,174)",
    type: "ImageBox",
    description: "Size: 32 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 205.2325581395349,
      y: 444.76744186046517,
    },
    bottomRight: {
      x: 207.55813953488374,
      y: 445.93023255813955,
    },
  },
  {
    id: "55ea4fb6-1a5e-4f2f-8a3f-84ab420bf1d8",
    label: "RGB(148,236,247)",
    type: "ImageBox",
    description: "Size: 53 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 361.3372093023256,
      y: 446.22093023255815,
    },
    bottomRight: {
      x: 365.1162790697675,
      y: 447.3837209302326,
    },
  },
  {
    id: "183877df-57d0-4f2f-adfc-eb017e7383de",
    label: "RGB(144,231,241)",
    type: "ImageBox",
    description: "Size: 13 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 347.6744186046512,
      y: 447.093023255814,
    },
    bottomRight: {
      x: 349.4186046511628,
      y: 448.25581395348837,
    },
  },
  {
    id: "511b0041-94f6-417e-aeb3-e91368c0d512",
    label: "RGB(150,244,255)",
    type: "ImageBox",
    description: "Size: 29 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 346.8023255813954,
      y: 447.3837209302326,
    },
    bottomRight: {
      x: 348.8372093023256,
      y: 448.546511627907,
    },
  },
  {
    id: "3fa74c13-ed18-4202-8ed5-421a2ab957d2",
    label: "RGB(252,229,172)",
    type: "ImageBox",
    description: "Size: 53 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 285.75581395348837,
      y: 447.6744186046512,
    },
    bottomRight: {
      x: 288.95348837209303,
      y: 449.1279069767442,
    },
  },
  {
    id: "75271d7b-0434-4f7d-84ef-70b5dea42f1b",
    label: "RGB(254,232,175)",
    type: "ImageBox",
    description: "Size: 78 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 233.13953488372096,
      y: 447.9651162790698,
    },
    bottomRight: {
      x: 235.7558139534884,
      y: 450.58139534883725,
    },
  },
  {
    id: "49a561bc-e588-47a1-aaf1-f952e461d67c",
    label: "RGB(181,255,176)",
    type: "ImageBox",
    description: "Size: 52 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 250.58139534883722,
      y: 447.9651162790698,
    },
    bottomRight: {
      x: 252.61627906976744,
      y: 450,
    },
  },
  {
    id: "984c27ac-a879-4124-9dd0-31640fc2b734",
    label: "RGB(254,232,174)",
    type: "ImageBox",
    description: "Size: 57 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 177.03488372093025,
      y: 448.546511627907,
    },
    bottomRight: {
      x: 180.5232558139535,
      y: 450.29069767441865,
    },
  },
  {
    id: "ed9bb523-d5fa-419c-9310-ac016bd466ce",
    label: "RGB(249,229,172)",
    type: "ImageBox",
    description: "Size: 87 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 267.1511627906977,
      y: 448.8372093023256,
    },
    bottomRight: {
      x: 270.34883720930236,
      y: 451.45348837209303,
    },
  },
  {
    id: "ce859b73-bd1d-480c-b86a-f0080b74d92a",
    label: "RGB(148,236,247)",
    type: "ImageBox",
    description: "Size: 42 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 308.72093023255815,
      y: 448.8372093023256,
    },
    bottomRight: {
      x: 311.6279069767442,
      y: 450,
    },
  },
  {
    id: "40f3e6aa-342a-486d-990b-ed3c82271bc7",
    label: "RGB(151,245,255)",
    type: "ImageBox",
    description: "Size: 58 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 247.96511627906978,
      y: 450.29069767441865,
    },
    bottomRight: {
      x: 250.87209302325581,
      y: 452.0348837209303,
    },
  },
  {
    id: "40ec4e91-da2d-4f93-b6c7-5c4b0a83c9f4",
    label: "RGB(252,230,172)",
    type: "ImageBox",
    description: "Size: 83 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 343.60465116279073,
      y: 450.87209302325584,
    },
    bottomRight: {
      x: 346.8023255813954,
      y: 453.19767441860466,
    },
  },
  {
    id: "e9f65c90-3320-4cbf-964b-2a2749358534",
    label: "RGB(179,250,173)",
    type: "ImageBox",
    description: "Size: 33 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 413.95348837209303,
      y: 451.45348837209303,
    },
    bottomRight: {
      x: 416.5697674418605,
      y: 452.6162790697675,
    },
  },
  {
    id: "df829b49-dd47-47ff-91c8-924d63af9957",
    label: "RGB(149,242,253)",
    type: "ImageBox",
    description: "Size: 29 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 231.1046511627907,
      y: 452.3255813953489,
    },
    bottomRight: {
      x: 233.43023255813955,
      y: 453.48837209302326,
    },
  },
  {
    id: "a5cfe8bb-6751-4a81-9677-47dea20e6ddd",
    label: "RGB(151,242,253)",
    type: "ImageBox",
    description: "Size: 68 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 265.98837209302326,
      y: 452.3255813953489,
    },
    bottomRight: {
      x: 269.1860465116279,
      y: 454.0697674418605,
    },
  },
  {
    id: "0f58b160-a352-4c17-9735-75936dc089f0",
    label: "RGB(255,233,174)",
    type: "ImageBox",
    description: "Size: 89 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 410.75581395348837,
      y: 452.3255813953489,
    },
    bottomRight: {
      x: 414.8255813953489,
      y: 454.6511627906977,
    },
  },
  {
    id: "4583beb3-2cf6-4ac0-984d-8ed72565f1c6",
    label: "RGB(179,250,173)",
    type: "ImageBox",
    description: "Size: 58 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 432.84883720930236,
      y: 452.3255813953489,
    },
    bottomRight: {
      x: 436.9186046511628,
      y: 453.48837209302326,
    },
  },
  {
    id: "3ff8f5be-72af-4652-8120-34e7794543bd",
    label: "RGB(249,229,172)",
    type: "ImageBox",
    description: "Size: 34 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 322.3837209302326,
      y: 453.19767441860466,
    },
    bottomRight: {
      x: 325,
      y: 454.3604651162791,
    },
  },
  {
    id: "78196b43-6d78-4833-8045-92ee844623ab",
    label: "RGB(179,249,172)",
    type: "ImageBox",
    description: "Size: 54 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 377.0348837209303,
      y: 453.19767441860466,
    },
    bottomRight: {
      x: 380.81395348837214,
      y: 454.3604651162791,
    },
  },
  {
    id: "cd8399d4-867e-4b1a-a0d1-68118fce08fd",
    label: "RGB(253,233,174)",
    type: "ImageBox",
    description: "Size: 58 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 245.34883720930233,
      y: 454.6511627906977,
    },
    bottomRight: {
      x: 248.2558139534884,
      y: 456.3953488372093,
    },
  },
  {
    id: "b69eeef7-1c93-4211-b5a6-f67182368500",
    label: "RGB(181,252,174)",
    type: "ImageBox",
    description: "Size: 17 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 208.43023255813955,
      y: 454.9418604651163,
    },
    bottomRight: {
      x: 209.59302325581396,
      y: 456.10465116279073,
    },
  },
  {
    id: "555add1b-3943-4bcd-8479-0a8df1a018b0",
    label: "RGB(177,247,170)",
    type: "ImageBox",
    description: "Size: 65 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 189.24418604651163,
      y: 455.52325581395354,
    },
    bottomRight: {
      x: 192.1511627906977,
      y: 457.26744186046517,
    },
  },
  {
    id: "93ccc047-c16d-487e-8db3-f038d253e4ea",
    label: "RGB(180,251,173)",
    type: "ImageBox",
    description: "Size: 198 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 273.25581395348837,
      y: 455.81395348837214,
    },
    bottomRight: {
      x: 280.5232558139535,
      y: 460.4651162790698,
    },
  },
  {
    id: "14c79872-529a-4459-b79b-a5c513eab37a",
    label: "RGB(152,246,255)",
    type: "ImageBox",
    description: "Size: 36 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 258.43023255813955,
      y: 456.10465116279073,
    },
    bottomRight: {
      x: 261.04651162790697,
      y: 457.26744186046517,
    },
  },
  {
    id: "435df44a-6214-4650-aa0d-eda34e9daef4",
    label: "RGB(181,252,174)",
    type: "ImageBox",
    description: "Size: 68 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 470.34883720930236,
      y: 456.3953488372093,
    },
    bottomRight: {
      x: 474.7093023255814,
      y: 457.84883720930236,
    },
  },
  {
    id: "a6846387-6260-4b60-88ba-bbf6a4c4d087",
    label: "RGB(185,255,176)",
    type: "ImageBox",
    description: "Size: 74 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 229.9418604651163,
      y: 456.6860465116279,
    },
    bottomRight: {
      x: 233.13953488372096,
      y: 458.72093023255815,
    },
  },
  {
    id: "e06276e7-c1e0-45df-a682-86ae818e3e53",
    label: "RGB(181,252,174)",
    type: "ImageBox",
    description: "Size: 70 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 281.9767441860465,
      y: 456.9767441860465,
    },
    bottomRight: {
      x: 286.6279069767442,
      y: 458.43023255813955,
    },
  },
  {
    id: "40c1f714-cafc-4cb5-bd44-f726dc223b64",
    label: "RGB(183,255,174)",
    type: "ImageBox",
    description: "Size: 29 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 360.4651162790698,
      y: 456.9767441860465,
    },
    bottomRight: {
      x: 363.08139534883725,
      y: 458.13953488372096,
    },
  },
  {
    id: "1ad20532-8e36-43cf-9f33-fcbbddb74c0a",
    label: "RGB(248,236,174)",
    type: "ImageBox",
    description: "Size: 103 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 362.2093023255814,
      y: 457.55813953488376,
    },
    bottomRight: {
      x: 368.31395348837214,
      y: 459.3023255813954,
    },
  },
  {
    id: "6ef9beff-aedf-4b60-805d-a1fd4879e394",
    label: "RGB(255,234,175)",
    type: "ImageBox",
    description: "Size: 46 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 461.046511627907,
      y: 457.55813953488376,
    },
    bottomRight: {
      x: 464.24418604651163,
      y: 458.72093023255815,
    },
  },
  {
    id: "2fc381d7-1ead-46d7-8e1f-e278e732e10c",
    label: "RGB(249,229,171)",
    type: "ImageBox",
    description: "Size: 59 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 224.7093023255814,
      y: 458.43023255813955,
    },
    bottomRight: {
      x: 227.90697674418607,
      y: 459.8837209302326,
    },
  },
  {
    id: "06797b06-bed3-4281-92e8-59372fc26145",
    label: "RGB(179,248,171)",
    type: "ImageBox",
    description: "Size: 61 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 448.546511627907,
      y: 458.72093023255815,
    },
    bottomRight: {
      x: 451.74418604651163,
      y: 460.1744186046512,
    },
  },
  {
    id: "ed25e2cd-6b7e-41c5-961c-20f1db2246d6",
    label: "RGB(181,252,173)",
    type: "ImageBox",
    description: "Size: 153 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 426.45348837209303,
      y: 459.0116279069768,
    },
    bottomRight: {
      x: 431.9767441860465,
      y: 462.79069767441865,
    },
  },
  {
    id: "4689d9ac-f3ef-40fa-a09a-71a61aba62a9",
    label: "RGB(177,247,170)",
    type: "ImageBox",
    description: "Size: 45 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 267.4418604651163,
      y: 459.3023255813954,
    },
    bottomRight: {
      x: 270.63953488372096,
      y: 460.4651162790698,
    },
  },
  {
    id: "4b2781b9-bcbf-46d2-aa6f-67f5449be923",
    label: "RGB(153,238,246)",
    type: "ImageBox",
    description: "Size: 54 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 178.77906976744188,
      y: 459.8837209302326,
    },
    bottomRight: {
      x: 181.68604651162792,
      y: 461.3372093023256,
    },
  },
  {
    id: "f2a91c1a-3b88-439c-870d-8310e724c469",
    label: "RGB(181,254,175)",
    type: "ImageBox",
    description: "Size: 49 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 252.32558139534885,
      y: 459.8837209302326,
    },
    bottomRight: {
      x: 254.6511627906977,
      y: 461.6279069767442,
    },
  },
  {
    id: "5624a1e1-95d2-429d-897f-2c8802cfe0f7",
    label: "RGB(183,254,175)",
    type: "ImageBox",
    description: "Size: 73 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 327.0348837209302,
      y: 459.8837209302326,
    },
    bottomRight: {
      x: 331.9767441860465,
      y: 461.6279069767442,
    },
  },
  {
    id: "47ec7282-a75a-4fb5-bd3b-1341512a73d0",
    label: "RGB(177,246,170)",
    type: "ImageBox",
    description: "Size: 122 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 311.6279069767442,
      y: 460.75581395348837,
    },
    bottomRight: {
      x: 315.69767441860466,
      y: 464.24418604651163,
    },
  },
  {
    id: "44f14064-c104-4e49-8be3-82b84952cc1c",
    label: "RGB(254,231,173)",
    type: "ImageBox",
    description: "Size: 79 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 236.046511627907,
      y: 461.3372093023256,
    },
    bottomRight: {
      x: 239.53488372093025,
      y: 463.66279069767444,
    },
  },
  {
    id: "6634df7e-d689-442a-9173-6f30a03f80b7",
    label: "RGB(148,236,245)",
    type: "ImageBox",
    description: "Size: 214 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 268.0232558139535,
      y: 461.3372093023256,
    },
    bottomRight: {
      x: 274.1279069767442,
      y: 466.5697674418605,
    },
  },
  {
    id: "9a9974f7-cd31-416b-9f85-47b3424a0c2a",
    label: "RGB(151,243,254)",
    type: "ImageBox",
    description: "Size: 121 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 370.34883720930236,
      y: 461.9186046511628,
    },
    bottomRight: {
      x: 374.7093023255814,
      y: 465.1162790697675,
    },
  },
  {
    id: "a3662707-9444-43a9-8303-304c44209ee4",
    label: "RGB(247,227,170)",
    type: "ImageBox",
    description: "Size: 97 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 439.5348837209303,
      y: 461.9186046511628,
    },
    bottomRight: {
      x: 446.51162790697674,
      y: 463.08139534883725,
    },
  },
  {
    id: "36bbfe5f-0cf0-4111-85e0-c807d90d6892",
    label: "RGB(255,233,174)",
    type: "ImageBox",
    description: "Size: 94 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 322.6744186046512,
      y: 462.2093023255814,
    },
    bottomRight: {
      x: 326.16279069767444,
      y: 465.1162790697675,
    },
  },
  {
    id: "7a1aa300-119b-46dd-92ad-dc2cd53e2fe9",
    label: "RGB(146,236,247)",
    type: "ImageBox",
    description: "Size: 87 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 395.34883720930236,
      y: 462.2093023255814,
    },
    bottomRight: {
      x: 398.546511627907,
      y: 464.8255813953489,
    },
  },
  {
    id: "60e77200-ca98-4855-9da9-d2ef6f34d355",
    label: "RGB(251,255,252)",
    type: "ImageBox",
    description: "Size: 477 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 398.8372093023256,
      y: 462.2093023255814,
    },
    bottomRight: {
      x: 409.593023255814,
      y: 477.3255813953489,
    },
  },
  {
    id: "ef022204-9933-4743-8e06-785b70148b4d",
    label: "RGB(175,244,168)",
    type: "ImageBox",
    description: "Size: 37 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 350.87209302325584,
      y: 462.79069767441865,
    },
    bottomRight: {
      x: 355.81395348837214,
      y: 463.95348837209303,
    },
  },
  {
    id: "2a1efc74-f018-496b-be3c-f43a0ee05a5b",
    label: "RGB(147,238,250)",
    type: "ImageBox",
    description: "Size: 220 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 244.18604651162792,
      y: 463.08139534883725,
    },
    bottomRight: {
      x: 251.45348837209303,
      y: 466.5697674418605,
    },
  },
  {
    id: "5507354d-88d7-4030-86c6-cb8b1dba39e4",
    label: "RGB(176,245,170)",
    type: "ImageBox",
    description: "Size: 24 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 138.95348837209303,
      y: 463.66279069767444,
    },
    bottomRight: {
      x: 140.69767441860466,
      y: 464.8255813953489,
    },
  },
  {
    id: "62b1d6de-53b5-4342-911e-ac0e4ceb3b09",
    label: "RGB(148,239,249)",
    type: "ImageBox",
    description: "Size: 135 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 290.98837209302326,
      y: 463.95348837209303,
    },
    bottomRight: {
      x: 297.6744186046512,
      y: 466.5697674418605,
    },
  },
  {
    id: "a8b7f15a-b048-43c7-988f-de4e03389672",
    label: "RGB(148,236,247)",
    type: "ImageBox",
    description: "Size: 111 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 309.593023255814,
      y: 464.24418604651163,
    },
    bottomRight: {
      x: 314.24418604651163,
      y: 466.5697674418605,
    },
  },
  {
    id: "2e8a8975-c150-492c-a603-a1daaaabd17d",
    label: "RGB(151,246,255)",
    type: "ImageBox",
    description: "Size: 120 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 323.8372093023256,
      y: 464.24418604651163,
    },
    bottomRight: {
      x: 329.6511627906977,
      y: 466.5697674418605,
    },
  },
  {
    id: "456b64de-3a31-4866-aa97-3ba07f16d504",
    label: "RGB(155,247,251)",
    type: "ImageBox",
    description: "Size: 143 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 349.1279069767442,
      y: 464.24418604651163,
    },
    bottomRight: {
      x: 356.10465116279073,
      y: 466.5697674418605,
    },
  },
  {
    id: "5fed9486-5e8b-4e1c-b625-5047cf6dd71e",
    label: "RGB(148,239,250)",
    type: "ImageBox",
    description: "Size: 73 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 443.60465116279073,
      y: 464.24418604651163,
    },
    bottomRight: {
      x: 447.3837209302326,
      y: 465.98837209302326,
    },
  },
  {
    id: "9133418b-e39b-4569-8c93-3d0328ca9277",
    label: "RGB(151,245,255)",
    type: "ImageBox",
    description: "Size: 84 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 424.4186046511628,
      y: 465.1162790697675,
    },
    bottomRight: {
      x: 428.19767441860466,
      y: 467.1511627906977,
    },
  },
  {
    id: "de7394f5-bf65-4abe-b880-59024761a5c0",
    label: "RGB(147,238,248)",
    type: "ImageBox",
    description: "Size: 102 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 470.05813953488376,
      y: 465.1162790697675,
    },
    bottomRight: {
      x: 474.7093023255814,
      y: 466.8604651162791,
    },
  },
  {
    id: "6a54ee6e-16a4-4398-9fff-aeaeb8ca49f5",
    label: "RGB(148,238,250)",
    type: "ImageBox",
    description: "Size: 48 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 168.6046511627907,
      y: 465.40697674418607,
    },
    bottomRight: {
      x: 171.80232558139537,
      y: 466.8604651162791,
    },
  },
  {
    id: "a93d8c79-520c-4841-8308-086e1d0a3dcb",
    label: "RGB(178,248,171)",
    type: "ImageBox",
    description: "Size: 36 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 193.0232558139535,
      y: 465.40697674418607,
    },
    bottomRight: {
      x: 195.63953488372096,
      y: 466.5697674418605,
    },
  },
  {
    id: "b3d904f4-e776-4a98-84a9-cacee801aaa2",
    label: "RGB(149,240,251)",
    type: "ImageBox",
    description: "Size: 98 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 186.62790697674419,
      y: 465.69767441860466,
    },
    bottomRight: {
      x: 192.1511627906977,
      y: 467.7325581395349,
    },
  },
  {
    id: "12af6aba-624b-4742-a01a-01684041fc4c",
    label: "RGB(151,245,255)",
    type: "ImageBox",
    description: "Size: 103 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 218.3139534883721,
      y: 465.69767441860466,
    },
    bottomRight: {
      x: 223.546511627907,
      y: 467.7325581395349,
    },
  },
  {
    id: "8a1534ce-89ab-4a64-bd30-9380ae0bf55e",
    label: "RGB(245,236,184)",
    type: "ImageBox",
    description: "Size: 42 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 286.3372093023256,
      y: 465.98837209302326,
    },
    bottomRight: {
      x: 289.8255813953489,
      y: 467.4418604651163,
    },
  },
  {
    id: "b5f57dd4-abb3-4155-b89e-a60837801e7f",
    label: "RGB(255,233,175)",
    type: "ImageBox",
    description: "Size: 86 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 396.51162790697674,
      y: 465.98837209302326,
    },
    bottomRight: {
      x: 400.58139534883725,
      y: 468.02325581395354,
    },
  },
  {
    id: "f3b7ff77-c8f2-448a-bcbf-853f79f570e7",
    label: "RGB(182,255,180)",
    type: "ImageBox",
    description: "Size: 33 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 246.80232558139537,
      y: 466.2790697674419,
    },
    bottomRight: {
      x: 250.00000000000003,
      y: 467.4418604651163,
    },
  },
  {
    id: "0db03d9e-3f81-45b7-a9f0-ca148ede3b39",
    label: "RGB(255,234,175)",
    type: "ImageBox",
    description: "Size: 128 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 255.2325581395349,
      y: 466.2790697674419,
    },
    bottomRight: {
      x: 258.72093023255815,
      y: 469.76744186046517,
    },
  },
  {
    id: "fec10b7c-1c70-451c-a36d-20fc98302ea4",
    label: "RGB(185,255,176)",
    type: "ImageBox",
    description: "Size: 63 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 419.4767441860465,
      y: 466.5697674418605,
    },
    bottomRight: {
      x: 422.9651162790698,
      y: 468.31395348837214,
    },
  },
  {
    id: "18d631e8-a76c-4b83-a3f3-cc8ec43fb3c6",
    label: "RGB(249,227,170)",
    type: "ImageBox",
    description: "Size: 65 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 410.4651162790698,
      y: 468.02325581395354,
    },
    bottomRight: {
      x: 414.24418604651163,
      y: 469.4767441860465,
    },
  },
  {
    id: "5b3ba7f0-17f7-48c6-8a14-ec686f0dd122",
    label: "RGB(177,247,171)",
    type: "ImageBox",
    description: "Size: 67 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 462.79069767441865,
      y: 468.60465116279073,
    },
    bottomRight: {
      x: 466.8604651162791,
      y: 470.34883720930236,
    },
  },
  {
    id: "374bb5cc-eb64-4f75-8009-80e9b4de133c",
    label: "RGB(246,224,169)",
    type: "ImageBox",
    description: "Size: 20 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 365.40697674418607,
      y: 469.1860465116279,
    },
    bottomRight: {
      x: 367.4418604651163,
      y: 470.34883720930236,
    },
  },
  {
    id: "47ad4a6f-a5f5-4562-8414-6e1a449f5d30",
    label: "RGB(252,230,173)",
    type: "ImageBox",
    description: "Size: 52 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 434.01162790697674,
      y: 469.1860465116279,
    },
    bottomRight: {
      x: 437.5,
      y: 470.34883720930236,
    },
  },
  {
    id: "b400eb7a-78ec-45ae-af8d-5de28c516a05",
    label: "RGB(177,246,170)",
    type: "ImageBox",
    description: "Size: 83 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 203.48837209302326,
      y: 469.4767441860465,
    },
    bottomRight: {
      x: 208.72093023255815,
      y: 470.63953488372096,
    },
  },
  {
    id: "2cd06675-9591-4aa7-b174-708c549df381",
    label: "RGB(147,238,250)",
    type: "ImageBox",
    description: "Size: 51 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 275.87209302325584,
      y: 469.4767441860465,
    },
    bottomRight: {
      x: 278.48837209302326,
      y: 471.22093023255815,
    },
  },
  {
    id: "fba9abd8-f23a-4b52-be81-9a8821609d30",
    label: "RGB(176,245,169)",
    type: "ImageBox",
    description: "Size: 129 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 303.48837209302326,
      y: 470.34883720930236,
    },
    bottomRight: {
      x: 307.55813953488376,
      y: 473.546511627907,
    },
  },
  {
    id: "84eb1c84-7b2d-431f-89fc-a910e90ce0b3",
    label: "RGB(254,234,175)",
    type: "ImageBox",
    description: "Size: 50 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 453.7790697674419,
      y: 470.34883720930236,
    },
    bottomRight: {
      x: 456.3953488372093,
      y: 471.8023255813954,
    },
  },
  {
    id: "428dd6d0-1605-4f36-b8af-e4300fff2c7a",
    label: "RGB(249,229,172)",
    type: "ImageBox",
    description: "Size: 18 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 157.84883720930233,
      y: 470.93023255813955,
    },
    bottomRight: {
      x: 159.01162790697674,
      y: 472.093023255814,
    },
  },
  {
    id: "19e509b5-f990-4d3d-aa3a-6058a153356f",
    label: "RGB(181,255,176)",
    type: "ImageBox",
    description: "Size: 101 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 333.43023255813955,
      y: 470.93023255813955,
    },
    bottomRight: {
      x: 336.9186046511628,
      y: 473.546511627907,
    },
  },
  {
    id: "d879d5b1-4c25-40ca-87bd-891b5d43d852",
    label: "RGB(176,246,169)",
    type: "ImageBox",
    description: "Size: 76 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 270.93023255813955,
      y: 471.5116279069768,
    },
    bottomRight: {
      x: 275.2906976744186,
      y: 473.2558139534884,
    },
  },
  {
    id: "c87d889a-b43e-4664-9f4a-270a06051191",
    label: "RGB(228,209,158)",
    type: "ImageBox",
    description: "Size: 32 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 317.1511627906977,
      y: 471.5116279069768,
    },
    bottomRight: {
      x: 319.4767441860465,
      y: 472.6744186046512,
    },
  },
  {
    id: "95ea78f7-9030-4116-9494-71282844cab5",
    label: "RGB(184,255,175)",
    type: "ImageBox",
    description: "Size: 105 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 486.6279069767442,
      y: 471.5116279069768,
    },
    bottomRight: {
      x: 490.40697674418607,
      y: 474.1279069767442,
    },
  },
  {
    id: "1eb65440-1d42-4a6d-b18d-d15176f8ede3",
    label: "RGB(180,251,173)",
    type: "ImageBox",
    description: "Size: 69 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 443.31395348837214,
      y: 471.8023255813954,
    },
    bottomRight: {
      x: 447.6744186046512,
      y: 473.546511627907,
    },
  },
  {
    id: "3836d59a-b0f2-44e5-aac8-085fe04e950c",
    label: "RGB(250,250,250)",
    type: "ImageBox",
    description: "Size: 4706 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 133.43023255813955,
      y: 472.3837209302326,
    },
    bottomRight: {
      x: 176.74418604651163,
      y: 545.9302325581396,
    },
  },
  {
    id: "8c658d90-cb8d-4f48-a146-1921aa2fc1fb",
    label: "RGB(252,230,173)",
    type: "ImageBox",
    description: "Size: 33 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 468.8953488372093,
      y: 472.3837209302326,
    },
    bottomRight: {
      x: 471.5116279069768,
      y: 473.546511627907,
    },
  },
  {
    id: "9397c3ba-350b-43f8-8d91-aaeb0b7b287e",
    label: "RGB(150,244,255)",
    type: "ImageBox",
    description: "Size: 100 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 472.3837209302326,
      y: 472.3837209302326,
    },
    bottomRight: {
      x: 477.6162790697675,
      y: 474.1279069767442,
    },
  },
  {
    id: "ac313766-a7ad-4514-bf81-b97aefb565b0",
    label: "RGB(255,237,177)",
    type: "ImageBox",
    description: "Size: 39 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 284.593023255814,
      y: 473.8372093023256,
    },
    bottomRight: {
      x: 287.2093023255814,
      y: 475,
    },
  },
  {
    id: "ab8da1e9-0faa-4cfc-a8c1-a605acdc7245",
    label: "RGB(255,233,175)",
    type: "ImageBox",
    description: "Size: 51 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 260.4651162790698,
      y: 474.1279069767442,
    },
    bottomRight: {
      x: 263.37209302325584,
      y: 475.58139534883725,
    },
  },
  {
    id: "8c8ab68a-172b-4c67-bf88-2d39ec3bf7a3",
    label: "RGB(177,246,170)",
    type: "ImageBox",
    description: "Size: 135 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 294.1860465116279,
      y: 474.4186046511628,
    },
    bottomRight: {
      x: 302.3255813953489,
      y: 475.87209302325584,
    },
  },
  {
    id: "19e9ef01-5235-40f0-8c10-91187228049e",
    label: "RGB(152,244,255)",
    type: "ImageBox",
    description: "Size: 112 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 431.10465116279073,
      y: 475.29069767441865,
    },
    bottomRight: {
      x: 437.2093023255814,
      y: 477.3255813953489,
    },
  },
  {
    id: "11d48ea4-4f87-415c-a432-633fb7a96b9c",
    label: "RGB(251,229,172)",
    type: "ImageBox",
    description: "Size: 77 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 177.90697674418607,
      y: 475.58139534883725,
    },
    bottomRight: {
      x: 181.39534883720933,
      y: 477.90697674418607,
    },
  },
  {
    id: "62b60ba0-c11a-4144-a160-5a95b4dd6db1",
    label: "RGB(245,225,170)",
    type: "ImageBox",
    description: "Size: 45 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 230.5232558139535,
      y: 475.87209302325584,
    },
    bottomRight: {
      x: 233.13953488372096,
      y: 477.3255813953489,
    },
  },
  {
    id: "d3b9d754-ad81-4336-8ad9-75fb19919536",
    label: "RGB(252,229,172)",
    type: "ImageBox",
    description: "Size: 40 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 272.3837209302326,
      y: 475.87209302325584,
    },
    bottomRight: {
      x: 274.7093023255814,
      y: 477.3255813953489,
    },
  },
  {
    id: "7040d745-5769-457d-911e-cb6e20f5a473",
    label: "RGB(179,248,171)",
    type: "ImageBox",
    description: "Size: 60 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 184.01162790697674,
      y: 476.16279069767444,
    },
    bottomRight: {
      x: 187.79069767441862,
      y: 477.6162790697675,
    },
  },
  {
    id: "acf7d760-1ee1-4612-ade3-28c1ab5f6d3e",
    label: "RGB(246,226,169)",
    type: "ImageBox",
    description: "Size: 101 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 342.4418604651163,
      y: 476.16279069767444,
    },
    bottomRight: {
      x: 348.25581395348837,
      y: 478.19767441860466,
    },
  },
  {
    id: "e9983776-ee30-414d-bd2a-25bcec2a6d75",
    label: "RGB(147,235,245)",
    type: "ImageBox",
    description: "Size: 85 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 394.1860465116279,
      y: 476.16279069767444,
    },
    bottomRight: {
      x: 399.7093023255814,
      y: 478.7790697674419,
    },
  },
  {
    id: "cc8de100-d7f0-4fab-b7fa-ecc1bdb7445a",
    label: "RGB(149,240,251)",
    type: "ImageBox",
    description: "Size: 141 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 422.6744186046512,
      y: 476.16279069767444,
    },
    bottomRight: {
      x: 429.3604651162791,
      y: 479.3604651162791,
    },
  },
  {
    id: "6b0ee5ca-de6b-49b4-a46b-bfbffc006dd6",
    label: "RGB(172,237,164)",
    type: "ImageBox",
    description: "Size: 38 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 170.05813953488374,
      y: 476.74418604651163,
    },
    bottomRight: {
      x: 172.67441860465118,
      y: 477.90697674418607,
    },
  },
  {
    id: "6a14e9f5-b316-49ff-94c5-c1cdd131bcc6",
    label: "RGB(246,226,169)",
    type: "ImageBox",
    description: "Size: 20 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 325.58139534883725,
      y: 476.74418604651163,
    },
    bottomRight: {
      x: 328.77906976744185,
      y: 477.90697674418607,
    },
  },
  {
    id: "bebf28f5-ef94-462e-be7a-18b7a1c4f054",
    label: "RGB(139,221,230)",
    type: "ImageBox",
    description: "Size: 11 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 236.3372093023256,
      y: 477.3255813953489,
    },
    bottomRight: {
      x: 237.5,
      y: 478.48837209302326,
    },
  },
  {
    id: "4a32d8a6-c435-488d-ad64-e2af20fbb6b1",
    label: "RGB(177,246,170)",
    type: "ImageBox",
    description: "Size: 116 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 376.16279069767444,
      y: 477.6162790697675,
    },
    bottomRight: {
      x: 383.13953488372096,
      y: 479.0697674418605,
    },
  },
  {
    id: "f7af98f8-a82d-41d9-8c29-a4371edb934f",
    label: "RGB(150,240,246)",
    type: "ImageBox",
    description: "Size: 66 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 351.74418604651163,
      y: 477.90697674418607,
    },
    bottomRight: {
      x: 354.6511627906977,
      y: 479.6511627906977,
    },
  },
  {
    id: "4fe83c7d-eaf2-4819-8a25-d67e9c579a99",
    label: "RGB(150,244,255)",
    type: "ImageBox",
    description: "Size: 103 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 275.87209302325584,
      y: 478.19767441860466,
    },
    bottomRight: {
      x: 279.6511627906977,
      y: 480.81395348837214,
    },
  },
  {
    id: "13264202-0a86-4090-b85f-8605cceaccaf",
    label: "RGB(188,255,177)",
    type: "ImageBox",
    description: "Size: 62 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 347.6744186046512,
      y: 478.19767441860466,
    },
    bottomRight: {
      x: 351.45348837209303,
      y: 479.9418604651163,
    },
  },
  {
    id: "b0a0a7f5-076e-4b55-ad07-531947d16f37",
    label: "RGB(161,222,154)",
    type: "ImageBox",
    description: "Size: 11 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 375.58139534883725,
      y: 478.19767441860466,
    },
    bottomRight: {
      x: 376.74418604651163,
      y: 479.3604651162791,
    },
  },
  {
    id: "fe033684-8646-4cb1-b4ce-49ee183d0857",
    label: "RGB(145,235,245)",
    type: "ImageBox",
    description: "Size: 53 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 457.26744186046517,
      y: 478.19767441860466,
    },
    bottomRight: {
      x: 461.3372093023256,
      y: 480.81395348837214,
    },
  },
  {
    id: "02b149ca-9597-4c5d-bd38-438a78a81579",
    label: "RGB(151,243,254)",
    type: "ImageBox",
    description: "Size: 60 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 220.34883720930233,
      y: 478.48837209302326,
    },
    bottomRight: {
      x: 222.96511627906978,
      y: 480.2325581395349,
    },
  },
  {
    id: "fd747164-f0a1-4367-b4af-c54fe5067127",
    label: "RGB(146,233,244)",
    type: "ImageBox",
    description: "Size: 45 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 294.1860465116279,
      y: 478.48837209302326,
    },
    bottomRight: {
      x: 296.8023255813954,
      y: 479.9418604651163,
    },
  },
  {
    id: "3219d3af-8e0d-4651-9277-209bf6883bf2",
    label: "RGB(178,251,173)",
    type: "ImageBox",
    description: "Size: 40 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 318.8953488372093,
      y: 478.48837209302326,
    },
    bottomRight: {
      x: 321.51162790697674,
      y: 479.6511627906977,
    },
  },
  {
    id: "cbc06f43-4fa5-4f60-a4ca-84f49d6102d1",
    label: "RGB(152,246,255)",
    type: "ImageBox",
    description: "Size: 131 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 458.43023255813955,
      y: 478.48837209302326,
    },
    bottomRight: {
      x: 463.66279069767444,
      y: 482.26744186046517,
    },
  },
  {
    id: "cfa93c94-81fc-4b9e-9e55-b662381ca1fe",
    label: "RGB(149,242,253)",
    type: "ImageBox",
    description: "Size: 60 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 128.48837209302326,
      y: 479.0697674418605,
    },
    bottomRight: {
      x: 131.3953488372093,
      y: 480.81395348837214,
    },
  },
  {
    id: "e0658998-e018-4879-8cc5-9b46fad9b0e6",
    label: "RGB(183,254,175)",
    type: "ImageBox",
    description: "Size: 99 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 251.74418604651163,
      y: 479.6511627906977,
    },
    bottomRight: {
      x: 254.9418604651163,
      y: 482.55813953488376,
    },
  },
  {
    id: "6d313caf-7de2-48dc-98aa-26f20a7d5917",
    label: "RGB(147,234,245)",
    type: "ImageBox",
    description: "Size: 39 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 257.84883720930236,
      y: 479.6511627906977,
    },
    bottomRight: {
      x: 260.4651162790698,
      y: 480.81395348837214,
    },
  },
  {
    id: "6da4a21c-c6d5-43e7-9f7c-e136f4fb2fa3",
    label: "RGB(148,238,250)",
    type: "ImageBox",
    description: "Size: 66 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 324.1279069767442,
      y: 479.6511627906977,
    },
    bottomRight: {
      x: 327.6162790697675,
      y: 481.3953488372093,
    },
  },
  {
    id: "27a95ffd-059b-4573-9d00-829f00dbba21",
    label: "RGB(185,255,176)",
    type: "ImageBox",
    description: "Size: 117 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 389.24418604651163,
      y: 479.9418604651163,
    },
    bottomRight: {
      x: 395.63953488372096,
      y: 481.3953488372093,
    },
  },
  {
    id: "098768b1-8716-410d-9db8-5ad5976d4a65",
    label: "RGB(146,233,244)",
    type: "ImageBox",
    description: "Size: 40 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 179.06976744186048,
      y: 480.52325581395354,
    },
    bottomRight: {
      x: 181.68604651162792,
      y: 481.6860465116279,
    },
  },
  {
    id: "b9f109b9-1cd6-4f35-8e73-c71419b8ebf3",
    label: "RGB(183,254,175)",
    type: "ImageBox",
    description: "Size: 80 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 232.55813953488374,
      y: 480.52325581395354,
    },
    bottomRight: {
      x: 236.9186046511628,
      y: 482.26744186046517,
    },
  },
  {
    id: "ec3e9ada-5d33-4f71-a0a4-b17f62d21fe3",
    label: "RGB(147,237,248)",
    type: "ImageBox",
    description: "Size: 151 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 284.30232558139534,
      y: 480.52325581395354,
    },
    bottomRight: {
      x: 288.66279069767444,
      y: 484.593023255814,
    },
  },
  {
    id: "ee0469cc-79e3-4799-b653-fa45c5454598",
    label: "RGB(252,229,172)",
    type: "ImageBox",
    description: "Size: 51 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 306.3953488372093,
      y: 480.52325581395354,
    },
    bottomRight: {
      x: 309.3023255813954,
      y: 481.6860465116279,
    },
  },
  {
    id: "bc82c565-dd10-423c-ba7d-8d1e1b2fce09",
    label: "RGB(181,255,176)",
    type: "ImageBox",
    description: "Size: 228 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 436.046511627907,
      y: 480.81395348837214,
    },
    bottomRight: {
      x: 445.93023255813955,
      y: 486.6279069767442,
    },
  },
  {
    id: "d8d29cec-1569-492f-90c3-2d090f2fcf9c",
    label: "RGB(147,237,247)",
    type: "ImageBox",
    description: "Size: 145 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 133.72093023255815,
      y: 481.10465116279073,
    },
    bottomRight: {
      x: 138.08139534883722,
      y: 485.1744186046512,
    },
  },
  {
    id: "155ba6d9-392b-4004-bdbe-466b9a4c6beb",
    label: "RGB(255,236,176)",
    type: "ImageBox",
    description: "Size: 44 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 491.8604651162791,
      y: 481.10465116279073,
    },
    bottomRight: {
      x: 494.76744186046517,
      y: 482.26744186046517,
    },
  },
  {
    id: "a9b5ebd7-1e0d-4df2-a913-69a02fe41c3a",
    label: "RGB(141,225,236)",
    type: "ImageBox",
    description: "Size: 13 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 158.72093023255815,
      y: 481.3953488372093,
    },
    bottomRight: {
      x: 159.88372093023256,
      y: 482.55813953488376,
    },
  },
  {
    id: "e1569afe-a683-40e3-9d24-e73db00a3a7e",
    label: "RGB(247,227,170)",
    type: "ImageBox",
    description: "Size: 31 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 195.63953488372096,
      y: 481.3953488372093,
    },
    bottomRight: {
      x: 198.546511627907,
      y: 482.55813953488376,
    },
  },
  {
    id: "63a55d27-cf8d-4623-81df-e46d5765ef27",
    label: "RGB(150,244,255)",
    type: "ImageBox",
    description: "Size: 82 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 356.9767441860465,
      y: 481.3953488372093,
    },
    bottomRight: {
      x: 362.2093023255814,
      y: 482.84883720930236,
    },
  },
  {
    id: "9fe148ba-63cd-4263-a3c7-b703f280a8ce",
    label: "RGB(255,233,174)",
    type: "ImageBox",
    description: "Size: 47 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 402.6162790697675,
      y: 481.3953488372093,
    },
    bottomRight: {
      x: 405.52325581395354,
      y: 482.84883720930236,
    },
  },
  {
    id: "3b4c847c-899e-4f12-bbf6-a4558fb1bbbe",
    label: "RGB(149,240,251)",
    type: "ImageBox",
    description: "Size: 66 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 386.3372093023256,
      y: 482.84883720930236,
    },
    bottomRight: {
      x: 390.69767441860466,
      y: 484.0116279069768,
    },
  },
  {
    id: "ef13a754-28f0-4f84-8fa8-3921e5017711",
    label: "RGB(151,242,252)",
    type: "ImageBox",
    description: "Size: 65 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 313.66279069767444,
      y: 483.43023255813955,
    },
    bottomRight: {
      x: 317.1511627906977,
      y: 485.1744186046512,
    },
  },
  {
    id: "31218230-920e-44cd-b163-100e29d297e8",
    label: "RGB(181,252,173)",
    type: "ImageBox",
    description: "Size: 64 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 220.63953488372096,
      y: 483.72093023255815,
    },
    bottomRight: {
      x: 224.12790697674419,
      y: 485.1744186046512,
    },
  },
  {
    id: "d746e1ee-c487-441d-b86f-786f845238ee",
    label: "RGB(247,227,170)",
    type: "ImageBox",
    description: "Size: 62 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 418.02325581395354,
      y: 483.72093023255815,
    },
    bottomRight: {
      x: 421.51162790697674,
      y: 485.1744186046512,
    },
  },
  {
    id: "5f04362b-5aec-490d-908f-271330d36496",
    label: "RGB(255,235,175)",
    type: "ImageBox",
    description: "Size: 60 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 452.0348837209303,
      y: 483.72093023255815,
    },
    bottomRight: {
      x: 454.9418604651163,
      y: 485.4651162790698,
    },
  },
  {
    id: "f3fc51f7-a4eb-4936-86bb-03bd84074725",
    label: "RGB(254,232,174)",
    type: "ImageBox",
    description: "Size: 55 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 471.8023255813954,
      y: 483.72093023255815,
    },
    bottomRight: {
      x: 475.58139534883725,
      y: 484.8837209302326,
    },
  },
  {
    id: "f4d060a2-e2ed-439a-a16f-c8c82ce0b789",
    label: "RGB(148,238,250)",
    type: "ImageBox",
    description: "Size: 134 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 483.72093023255815,
      y: 483.72093023255815,
    },
    bottomRight: {
      x: 490.1162790697675,
      y: 486.046511627907,
    },
  },
  {
    id: "e9947787-3a65-4cd0-9654-be69739880aa",
    label: "RGB(177,246,170)",
    type: "ImageBox",
    description: "Size: 163 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 295.93023255813955,
      y: 484.3023255813954,
    },
    bottomRight: {
      x: 300.58139534883725,
      y: 488.08139534883725,
    },
  },
  {
    id: "a1849098-879d-4921-ad65-bbc6c3ced06a",
    label: "RGB(176,243,168)",
    type: "ImageBox",
    description: "Size: 18 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 159.01162790697674,
      y: 484.8837209302326,
    },
    bottomRight: {
      x: 160.17441860465118,
      y: 486.6279069767442,
    },
  },
  {
    id: "8f3fd5af-0cc9-42ae-a7f1-b3d2329e94b9",
    label: "RGB(184,255,176)",
    type: "ImageBox",
    description: "Size: 33 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 159.59302325581396,
      y: 484.8837209302326,
    },
    bottomRight: {
      x: 161.3372093023256,
      y: 486.3372093023256,
    },
  },
  {
    id: "1d0d5d76-1a1f-41e4-a4c2-0755b0a01993",
    label: "RGB(178,248,171)",
    type: "ImageBox",
    description: "Size: 63 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 269.4767441860465,
      y: 484.8837209302326,
    },
    bottomRight: {
      x: 272.9651162790698,
      y: 486.3372093023256,
    },
  },
  {
    id: "78bd9557-44b9-473f-8dd6-a59a9c8dba92",
    label: "RGB(255,234,176)",
    type: "ImageBox",
    description: "Size: 49 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 339.24418604651163,
      y: 485.1744186046512,
    },
    bottomRight: {
      x: 342.1511627906977,
      y: 486.6279069767442,
    },
  },
  {
    id: "5f3adcdd-fb46-4c43-ab41-fa62f285ac63",
    label: "RGB(152,244,255)",
    type: "ImageBox",
    description: "Size: 78 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 240.69767441860466,
      y: 485.7558139534884,
    },
    bottomRight: {
      x: 244.47674418604652,
      y: 487.5,
    },
  },
  {
    id: "dcfea169-24a6-4117-8b01-bc2c91d4cc76",
    label: "RGB(252,230,172)",
    type: "ImageBox",
    description: "Size: 46 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 368.8953488372093,
      y: 486.3372093023256,
    },
    bottomRight: {
      x: 371.8023255813954,
      y: 487.5,
    },
  },
  {
    id: "ddb880be-8437-4047-b800-15646c9f2214",
    label: "RGB(177,247,171)",
    type: "ImageBox",
    description: "Size: 66 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 114.53488372093024,
      y: 486.6279069767442,
    },
    bottomRight: {
      x: 117.44186046511629,
      y: 488.66279069767444,
    },
  },
  {
    id: "801d88f3-c932-4ef4-8327-b5b352621e2c",
    label: "RGB(185,255,176)",
    type: "ImageBox",
    description: "Size: 110 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 185.75581395348837,
      y: 487.2093023255814,
    },
    bottomRight: {
      x: 190.11627906976744,
      y: 489.5348837209303,
    },
  },
  {
    id: "dc326caa-0f35-411a-abd8-4567e0772d22",
    label: "RGB(177,250,172)",
    type: "ImageBox",
    description: "Size: 76 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 325,
      y: 487.2093023255814,
    },
    bottomRight: {
      x: 329.3604651162791,
      y: 488.66279069767444,
    },
  },
  {
    id: "eb4bae42-fa93-492b-b5b0-fb3a6a4459ee",
    label: "RGB(252,230,173)",
    type: "ImageBox",
    description: "Size: 58 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 353.77906976744185,
      y: 487.2093023255814,
    },
    bottomRight: {
      x: 356.6860465116279,
      y: 488.95348837209303,
    },
  },
  {
    id: "9f849458-c4f7-4470-8aee-42b78e9f6754",
    label: "RGB(249,227,170)",
    type: "ImageBox",
    description: "Size: 66 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 310.1744186046512,
      y: 488.08139534883725,
    },
    bottomRight: {
      x: 313.37209302325584,
      y: 489.8255813953489,
    },
  },
  {
    id: "ee773927-a493-4bea-8f24-9386fd739a0d",
    label: "RGB(254,232,173)",
    type: "ImageBox",
    description: "Size: 47 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 282.55813953488376,
      y: 488.37209302325584,
    },
    bottomRight: {
      x: 285.75581395348837,
      y: 489.8255813953489,
    },
  },
  {
    id: "9504b9da-0cb2-492c-a0d9-80e72cc71096",
    label: "RGB(255,236,177)",
    type: "ImageBox",
    description: "Size: 44 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 209.01162790697677,
      y: 488.66279069767444,
    },
    bottomRight: {
      x: 211.9186046511628,
      y: 490.1162790697675,
    },
  },
  {
    id: "3a803e66-e408-46ad-a992-be120ef87247",
    label: "RGB(151,245,255)",
    type: "ImageBox",
    description: "Size: 54 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 198.546511627907,
      y: 489.24418604651163,
    },
    bottomRight: {
      x: 202.03488372093025,
      y: 490.40697674418607,
    },
  },
  {
    id: "8e35d358-9b60-4f83-9508-96b9023d4dd1",
    label: "RGB(253,231,173)",
    type: "ImageBox",
    description: "Size: 57 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 231.39534883720933,
      y: 489.24418604651163,
    },
    bottomRight: {
      x: 234.59302325581396,
      y: 490.69767441860466,
    },
  },
  {
    id: "c32e0fa1-771c-40b1-9f33-e08f8ea48dde",
    label: "RGB(252,229,174)",
    type: "ImageBox",
    description: "Size: 59 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 251.16279069767444,
      y: 489.5348837209303,
    },
    bottomRight: {
      x: 254.06976744186048,
      y: 491.2790697674419,
    },
  },
  {
    id: "63721cfb-77c6-4184-ab4c-11bc915fde3d",
    label: "RGB(148,238,249)",
    type: "ImageBox",
    description: "Size: 80 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 164.82558139534885,
      y: 491.8604651162791,
    },
    bottomRight: {
      x: 170.05813953488374,
      y: 493.31395348837214,
    },
  },
  {
    id: "0f06cf30-3846-4a3d-9cf0-f314a5021547",
    label: "RGB(222,222,222)",
    type: "ImageBox",
    description: "Size: 22 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 150,
      y: 518.0232558139535,
    },
    bottomRight: {
      x: 152.32558139534885,
      y: 520.639534883721,
    },
  },
  {
    id: "1b119f76-6e46-4127-899c-7658c1fc3e0e",
    label: "RGB(236,236,236)",
    type: "ImageBox",
    description: "Size: 28 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 150.87209302325581,
      y: 519.4767441860465,
    },
    bottomRight: {
      x: 153.77906976744188,
      y: 520.9302325581396,
    },
  },
  {
    id: "7b1fe6b6-f68e-4e58-b5d6-857e005cba4e",
    label: "RGB(248,248,248)",
    type: "ImageBox",
    description: "Size: 1028 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 151.45348837209303,
      y: 520.0581395348837,
    },
    bottomRight: {
      x: 168.6046511627907,
      y: 550.2906976744187,
    },
  },
  {
    id: "76585296-a132-45a3-92da-fcaddb312fa1",
    label: "RGB(67,67,67)",
    type: "ImageBox",
    description: "Size: 16 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 147.09302325581396,
      y: 535.1744186046512,
    },
    bottomRight: {
      x: 149.12790697674419,
      y: 537.5,
    },
  },
  {
    id: "86e88fad-3752-4dbe-b563-50fae7c93138",
    label: "RGB(90,90,90)",
    type: "ImageBox",
    description: "Size: 12 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 147.38372093023256,
      y: 535.4651162790698,
    },
    bottomRight: {
      x: 148.546511627907,
      y: 537.5,
    },
  },
  {
    id: "da86face-70b1-4bc2-84c1-addd0d556690",
    label: "RGB(157,157,157)",
    type: "ImageBox",
    description: "Size: 10 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 146.51162790697674,
      y: 536.3372093023256,
    },
    bottomRight: {
      x: 147.96511627906978,
      y: 537.5,
    },
  },
  {
    id: "8c3cd1e8-fdca-41be-b2e2-3a532b9b0c1d",
    label: "RGB(195,195,195)",
    type: "ImageBox",
    description: "Size: 11 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 146.22093023255815,
      y: 536.9186046511628,
    },
    bottomRight: {
      x: 147.38372093023256,
      y: 538.0813953488372,
    },
  },
  {
    id: "6446d1b9-a4ab-43a2-8f5b-2cec83777856",
    label: "RGB(211,211,211)",
    type: "ImageBox",
    description: "Size: 13 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 145.63953488372093,
      y: 537.5,
    },
    bottomRight: {
      x: 147.09302325581396,
      y: 538.953488372093,
    },
  },
  {
    id: "d1deee22-4f79-4265-bb1c-a170531c00f1",
    label: "RGB(226,226,226)",
    type: "ImageBox",
    description: "Size: 21 pixels",
    imageUrl: "/images/art/Untitled_Artwork 256.png",
    topLeft: {
      x: 144.47674418604652,
      y: 537.7906976744187,
    },
    bottomRight: {
      x: 146.80232558139537,
      y: 539.2441860465117,
    },
  },
];
